import { registerAiCapability } from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";
import { isCaregiverMemoryImprovementsEnabled } from "@medflyt/webapp-react/src/modules/betaFeatures/betaFeatures.store";
import CommunicationCenterTicketRoute from "@medflyt/webapp-react/src/modules/communication/pages/CommunicationCenterTicket/CommunicationCenterTicketRoute";
import OpenCommunicationsRoute from "@medflyt/webapp-react/src/modules/communication/pages/OpenCommunications/OpenCommunicationsRoute";
import WorkflowTasksRoute from "@medflyt/webapp-react/src/modules/workflow/pages/WorkflowTasks/WorkflowTasksRoute";
import WorkflowTaskViewerRoute from "@medflyt/webapp-react/src/modules/workflow/pages/WorkflowTaskViewer/WorkflowTaskViewerRoute";
import WorkflowSkillsRoute from "@medflyt/webapp-react/src/modules/workflow/pages/WorkflowSkills/WorkflowSkillsRoute";
import IntakeRoute from "@medflyt/webapp-react/src/modules/patientIntake/pages/dashboard/IntakeRoute";
import ReferralsDashboardRoute from "@medflyt/webapp-react/src/modules/referral/pages/dashboard/ReferralsDashboardRoute";
import OpenFaxDashboardRoute from "@medflyt/webapp-react/src/modules/fax/pages/OpenFaxDashboardRoute";
import PatientIntakeFlowPage from "@medflyt/webapp-react/src/modules/patientIntake/pages/flow/PatientIntakeFlowPage";
import PatientComplianceRoute from "@medflyt/webapp-react/src/modules/patient/pages/compliance/PatientComplianceRoute";
import CaregiverSuppliesShipmentsRoute from "@medflyt/webapp-react/src/modules/caregiverSuppliesShipments/pages/CaregiverSuppliesShipmentsRoute";
import PatientIntakeFlowSettingsRoute from "@medflyt/webapp-react/src/modules/patientIntake/pages/flow-settings/PatientIntakeFlowSettingsRoute";
import PatientsDashboardRoute from "@medflyt/webapp-react/src/modules/patient/pages/dashboard/PatientsDashboardRoute";
import PayrollVerificationRoute from "@medflyt/webapp-react/src/modules/payroll/pages/PayrollVerification/PayrollVerificationRoute";
import PayrollAuditRoute from "@medflyt/webapp-react/src/modules/payroll/pages/PayrollAudit/PayrollAuditRoute";
import PromptTestingRoute from "@medflyt/webapp-react/src/modules/prompt-testing/pages/PromptTestingRoute";
import CaregiverExclusionsRoute from "@medflyt/webapp-react/src/modules/caregiver/pages/exclusions/CaregiverExclusionsRoute";
import CaregiversDashboardRoute from "@medflyt/webapp-react/src/modules/caregiver/pages/dashboard/CaregiversDashboardRoute";
import VisitAssignmentsRoute from "@medflyt/webapp-react/src/modules/visit/pages/assignments/VisitAssignmentsRoute";
import AuthorizedPatientsWithoutVisitsRoute from "@medflyt/webapp-react/src/modules/authorized-patients-without-visits/AuthorizedPatientsWithoutVisitsRoute";
import CICOReportsRoute from "@medflyt/webapp-react/src/modules/cico-reports/CicoIssuesVisitsRoute";
import ClockedVisitsGraphQLRoute from "@medflyt/webapp-react/src/modules/cico-reports/ClockedVisitsGraphQLRoute";
import EvvDutyCodeMappingRoute from "@medflyt/webapp-react/src/modules/evv-duty-code-mapping/EvvDutyCodeMappingRoute";
import EvvDevHelpDashboardRoute from "@medflyt/webapp-react/src/modules/evv-dev-help/EvvDevHelpDashboardRoute";
import PayerHhaxPocMappingRoute from "@medflyt/webapp-react/src/modules/evv-duty-code-mapping/PayerHhaxPocMappingRoute";
import AdministrativePaymentRoute from "@medflyt/webapp-react/src/modules/billing/pages/administrative-payment/AdministrativePaymentRoute";
import AgencyBillingRoute from "@medflyt/webapp-react/src/modules/billing/pages/agency-billing/AgencyBillingRoute";
// TEMP: Adjustment Approvals (New) — hidden until the GraphQL view is fast enough for production.
// import AdjustmentApprovalsNewRoute from "@medflyt/webapp-react/src/modules/billing/pages/adjustment-approvals-new/AdjustmentApprovalsNewRoute";
import BankedMinutesRoute from "@medflyt/webapp-react/src/modules/billing/pages/banked-minutes/BankedMinutesRoute";
import AuthorizationUtilizationRoute from "@medflyt/webapp-react/src/modules/authorization-utilization/AuthorizationUtilizationRoute";
import UploadsRoute from "@medflyt/webapp-react/src/modules/billing/pages/uploads/UploadsRoute";
import { WithAppInRouter } from "@medflyt/webapp-react/src/utils";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { DayOfWeek, LocalDate } from "@js-joda/core";
import * as Sentry from "@sentry/browser";
import { ComplianceDocumentReviewScreenComponent } from "../modules/compliance/components/compliance-document-review/compliance-document-review.component";
import { PrioritizedCaregiversScreenComponent } from "../modules/compliance/components/prioritized-caregivers/prioritized-caregivers.component";
import { AiReviewManualCheckComponent } from "../modules/compliance/components/ai-review-manual-check/ai-review-manual-check.component";
import { getParameterByName } from "./getParameterByName";
import logrocket from "@medflyt/webapp-react/src/shared/utils/logrocket";
import React from "react";
import PatientIssuesRoute from "@medflyt/webapp-react/src/modules/patientIssues/PatientIssuesRoute";
import ServicePlansDashboardRoute from "@medflyt/webapp-react/src/modules/servicePlan/ServicePlansDashboardRoute";
import DailyNotesRoute from "@medflyt/webapp-react/src/modules/dailyNotes/DailyNotesRoute";
import CaregiverHcrStateComplianceRoute from "@medflyt/webapp-react/src/modules/state-compliance/hcr/CaregiverHcrStateComplianceRoute";
import CaregiverChrcStateComplianceRoute from "@medflyt/webapp-react/src/modules/state-compliance/chrc/CaregiverChrcStateComplianceRoute";
import CaregiverStateComplianceIssuesPage from "@medflyt/webapp-react/src/modules/state-compliance/issues/CaregiverStateComplianceIssuesPage";
import { isBetaProfileWindowEnabled } from "@medflyt/webapp-react/src/modules/profileWindowSettings/profileWindowSettings.store";

// Not a plain `!id` check: NaN and the empty string have to be rejected
// explicitly, and an id of 0 is falsy without being missing.
/**
 * Whether the caregiver memory improvements are on for this browser. Only the
 * caregiver half is asked here - the patient half switches a React route, which
 * reads it for itself.
 *
 * Read once at load rather than per call: the router states and the navigation
 * items are both built at bootstrap, so the switch takes effect on the next page
 * load. Reading it later would let the two disagree - a navigation item pointing
 * at a state that was never registered.
 */
const useCaregiverMemoryImprovements = isCaregiverMemoryImprovementsEnabled();

function isMissingEntityModalId(id) {
  return id === undefined || id === null || id === "" || (typeof id === "number" && Number.isNaN(id));
}

/* @ngInject */
export function config($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, ngTableFilterConfigProvider, LightboxProvider) {
  // The Angular caregivers list was replaced by the React one, and is kept
  // behind the "Caregiver and patient memory improvements" beta switch. With the
  // improvements on there is no Angular page to route to, so the old URLs - which
  // are bookmarked and linked from elsewhere - redirect to the React one. The
  // paths need the /app prefix the parent state contributes, or they fall through
  // to `otherwise` and land on the dashboard instead of the caregivers list.
  if (useCaregiverMemoryImprovements) {
    // The redirect has to carry the query string across itself. A string handler
    // is compiled into a UrlMatcher and formatted with only the params the
    // *source* pattern declares - none, here - and the result then replaces the
    // whole URL, so `?caregiver=<id>` was dropped and the profile never opened.
    // Those are the links getCaregiverPageURL builds and the onSuccess hook below
    // reads, so they arrive from bookmarks, emails and "open in new tab".
    //
    // Taken verbatim off $location rather than re-serialised from search(): that
    // keeps repeated params, valueless flags and the original encoding intact.
    const toCaregiversNew = ["$location", function($location) {
      const url = $location.url();
      const suffixAt = url.search(/[?#]/);

      return "/app/caregivers-new" + (suffixAt === -1 ? "" : url.slice(suffixAt));
    }];

    $urlRouterProvider.when("/app/professionals/caregivers", toCaregiversNew);
    $urlRouterProvider.when("/app/professionals/pendingAcceptance", toCaregiversNew);
    $urlRouterProvider.when("/app/professionals", toCaregiversNew);
  }
  $urlRouterProvider.otherwise("/app/dashboard");
  $locationProvider.html5Mode(true);
  $httpProvider.interceptors.push('authInterceptor');

  $stateProvider
    .state('app', {
      abstract: true,
      url: "/app",
      templateUrl: "admin/views/common/content.html",
      resolve: {
        connect: function(DatabaseApi) {
          return true
        }
      }
    })
    .state('app.profile', {
      url: "/profile",
      templateUrl: "admin/views/profile.html",
      data: {
        pageTitle: 'Profile'
      },
      controller: 'profileCtrl'
    })
    .state('app.payment', {
      url: "/payment",
      component: WithAppInRouter(AgencyBillingRoute),
      data: {
        pageTitle: 'Billing'
      }
    })
    .state('app.tutorial', {
      url: "/tutorial",
      templateUrl: "admin/views/tutorial.html",
      data: {
        pageTitle: 'Tutorial'
      },
      controller: 'tutorialCtrl'
    })
    .state('app.sweep', {
      url: "/sweepstakes",
      templateUrl: "admin/views/sweep.html",
      data: {
        pageTitle: 'SweepStakes'
      },
      controller: 'sweepCtrl'
    })
    .state('app.invite', {
      url: "/invite",
      templateUrl: "admin/views/invite.html",
      data: {
        pageTitle: 'Invite Team Members'
      },
      controller: 'inviteCtrl'
    })
    .state('app.caregiversNew', {
      url: "/caregivers-new",
      data: {
        pageTitle: 'Caregivers'
      },
      component: WithAppInRouter(CaregiversDashboardRoute)
    })
    .state('app.onboarding', {
      url: "/onboarding",
      templateUrl: "admin/views/professionals-onboarding.html",
      data: {
        pageTitle: 'Onboarding'
      },
      controller: 'professionalsOnboardingCtrl'
    })
    .state('app.onboarding.pendingApplication', {
      url: "/pendingApplication",
      templateUrl: "admin/views/caregivers-pending-application.html",
      data: {
        pageTitle: 'Pending Application'
      },
      controller: 'caregiversPendingApplicationCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.onboarding.OnboardingCaregivers', {
      url: "/OnboardingCaregivers",
      component: "onboardingComponent",
      data: {
        pageTitle: 'Onboarding Caregivers'
      }
    })
    .state('app.exclusionLists', {
      url: "/exclusion-lists",
      data: {
        pageTitle: 'Exclusions'
      },
      component: WithAppInRouter(CaregiverExclusionsRoute)
    })
    .state('app.orientationCenter', {
      url: "/orientation-center",
      templateUrl: "admin/views/orientation-center.html",
      data: {
        pageTitle: 'Orientation Center'
      },
      controller: 'orientationCenterCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      },
    })
    .state('app.caregiversCompliance', {
      url: "/caregivers-compliance",
      templateUrl: "admin/modules/compliance/views/caregivers-compliance.html",
      data: {
        pageTitle: 'Compliance'
      },
      controller: 'caregiversComplianceCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.caregiversTrainingCenterOverview', {
      url: "/caregivers/training-center-overview",
      templateUrl: "admin/views/caregivers-training-center-overview.html",
      data: {
        pageTitle: 'Caregivers - Training Center Overview'
      },
      controller: 'CaregiversTrainingCenterOverview',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.caregiversPrioritized', {
      url: "/caregivers/prioritized-caregivers",
      data: {
        pageTitle: 'Prioritized Caregivers'
      },
      component: PrioritizedCaregiversScreenComponent.$name
    })
    .state('app.caregiversAiReviewManualCheck', {
      url: "/caregivers/ai-review-manual-check",
      data: {
        pageTitle: 'AI Review Manual Check'
      },
      component: AiReviewManualCheckComponent.$name
    })
    // SHOULD BE ORIENTATION
    // .state('app.onboarding.caregiversTrainingCenterOverview', {
    //     url: "/caregivers/training-center-overview",
    //     templateUrl: "admin/views/caregivers-training-center-overview.html",
    //     data: { pageTitle: 'Caregivers - Training Center Overview' },
    //     controller: 'CaregiversTrainingCenterOverview',
    //     resolve: {
    //         pros: function (DatabaseApi) {
    //             return DatabaseApi.caregivers();
    //         },
    //         offices: function ($rootScope, officesService) {
    //             if (!officesService.offices) {
    //                 return officesService.getOffices();
    //             } else {
    //                 return officesService.offices;
    //             }
    //         }
    //     }
    // })
    .state('app.anomalies', {
      url: "/anomalies",
      templateUrl: "admin/views/anomalies.html",
      data: {
        pageTitle: 'Caregiver Anomalies'
      },
      controller: 'anomaliesCtrl'
    })
    .state('app.patients', {
      url: "/patients",
      template: '<div ui-view></div>'
    })
      .state('app.patients.dashboard', {
          url: "/dashboard",
          data: { pageTitle: 'Patients' },
          params: { createPatientParams: null, },
        component: WithAppInRouter(PatientsDashboardRoute)
      })
      .state('app.patients.dashboard_legacy', {
          url: "/dashboard_legacy?view",
          templateUrl: "admin/views/patients.html",
          data: { pageTitle: 'Patients' },
          params: { createPatientParams: null, view: null },
          controller: 'patientsCtrl',
      })
        .state('app.patients.dashboard.profile', {
          url: "/dashboard?{patient:int}",
          templateUrl: "admin/views/patients.html",
          data: { pageTitle: 'Patients' },
          controller: 'patientsCtrl',
          permissionKeys: ['view_patient_profile']
      })
    .state('app.patients.servicePlans', {
      url: "/servicePlans",
      data: {
        pageTitle: "Service Plans"
      },
      component: WithAppInRouter(ServicePlansDashboardRoute)
    })
    .state('app.patients.servicePlans.imports', {
      url: "/imports?servicePlanJobId"
    })
    .state('app.patients.servicePlans.plans', {
      url: "/plans"
    })
    .state('app.patients.careAndTaskManagement', {
      url: "/careAndTaskManagement",
      templateUrl: "admin/views/patient-care-and-task.html",
      data: {
        pageTitle: "Care & Task Management"
      },
      controller: 'patientCareAndTaskCtrl'
    })
    .state('app.patients.careAndTaskManagement.upcomingTasks', {
      url: "/tasks",
      templateUrl: "admin/views/patients-upcoming-tasks.html",
      data: {
        pageTitle: "Upcoming Tasks"
      },
      controller: 'patientsUpcomingTasksCtrl'
    })
    .state('app.patients.careAndTaskManagement.careManagement', {
      url: "/careManagement",
      templateUrl: "admin/views/care-management.html",
      data: {
        pageTitle: "Visits Care Management"
      },
      controller: 'careManagementCtrl'
    })
    .state('app.patients.careAndTaskManagement.certificationPeriods', {
      url: "/certificationPeriods",
      templateUrl: "admin/views/certification-periods.html",
      data: {
        pageTitle: "Certification Periods"
      },
      controller: 'certificationPeriodsCtrl'
    })
    .state('app.patients.careAndTaskManagement.patientsDocuments', {
      url: "/patientsDocuments",
      templateUrl: "admin/views/patients-documents.html",
      data: {
        pageTitle: "Patients Documents"
      },
      controller: "patientsDocumentsCtrl",
      controllerAs: "ctrl"
    })
    .state('app.patients.careAndTaskManagement.tasksNew', {
      url: "/tasks-new",
      templateUrl: "admin/views/patients-tasks-new.html",
      data: {
        pageTitle: "Tasks (new)"
      }
    })
    .state('app.patients.careAndTaskManagement.tasksV2', {
      // The filters and the open task live in the URL so a link reproduces what was on screen.
      // All dynamic: changing them re-renders the React page instead of rebuilding the view.
      // Untyped strings on purpose: a value ui-router cannot read fails the whole URL and lands on
      // the dashboard, so the page parses them itself and drops what it cannot read.
      url: "/tasks-2?{scheduledFrom}&{scheduledTo}&{statuses}&{taskTemplateIds}&{caregiverIds}&{patientIds}&{contractTypeIds}&{officeIds}&{page}&{pageSize}&{sortDirection}&{taskInstanceId}&{reviewDocumentTypeId}",
      params: {
        scheduledFrom: { value: null, squash: true, dynamic: true },
        scheduledTo: { value: null, squash: true, dynamic: true },
        statuses: { value: null, squash: true, dynamic: true, array: true },
        taskTemplateIds: { value: null, squash: true, dynamic: true, array: true },
        caregiverIds: { value: null, squash: true, dynamic: true, array: true },
        patientIds: { value: null, squash: true, dynamic: true, array: true },
        contractTypeIds: { value: null, squash: true, dynamic: true, array: true },
        officeIds: { value: null, squash: true, dynamic: true, array: true },
        page: { value: null, squash: true, dynamic: true },
        pageSize: { value: null, squash: true, dynamic: true },
        sortDirection: { value: null, squash: true, dynamic: true },
        taskInstanceId: { value: null, squash: true, dynamic: true },
        reviewDocumentTypeId: { value: null, squash: true, dynamic: true }
      },
      templateUrl: "admin/views/patients-tasks-v2.html",
      data: {
        pageTitle: "Tasks 2.0"
      }
    })
    .state('app.patients.careAndTaskManagement.rnSchedulingMap', {
      url: "/rn-scheduling-map",
      templateUrl: "admin/views/rn-scheduling-map.html",
      data: {
        pageTitle: "RN Scheduling Map"
      }
    })
    .state('app.patients.patientAlerts', {
      url: "/alerts",
      templateUrl: "admin/views/patient-alerts.html",
      data: {
        pageTitle: "Patient Alerts"
      },
      controller: 'patientAlertsCtrl'
    })
    .state('app.patients.medicalStatistics', {
      url: "/medical-statistics",
      templateUrl: "admin/views/patient-medical-statistics.html",
      data: {
        pageTitle: "Quality Of Care"
      },
      controller: 'patientMedicalStatisticsCtrl'
    })
    .state('app.mergePatients', {
      url: "/merge-patients",
      templateUrl: "admin/views/merge-patients.html",
      data: {
        pageTitle: 'Merge Patients'
      },
      controller: 'mergePatientsCtrl'
    })
    .state('app.patients.eligibilityChecks', {
      url: "/eligibility-checks",
      data: {
        pageTitle: "Eligibility Checks"
      },
      component: 'eligibilityChecksPage'
    })
    .state("app.patients.intake", {
      url: "/patient-intake",
      component: WithAppInRouter(IntakeRoute),
    })
    .state("app.patients.promptTesting", {
      url: "/prompt-testing",
      data: {
        pageTitle: "Prompt Testing"
      },
      component: WithAppInRouter(PromptTestingRoute),
    })
    .state("app.patients.intake.dashboard", { url: "/dashboard" })
    .state("app.patients.intake.dashboard.profile", {
        url: "/:patientId",
        params: {
          patientId: null
        }
      })
    .state("app.patients.intake.plans", { url: "/plans" })
    .state("app.patients.intake.referral-users", { url: "/referral-users" })
    .state("app.patients.intake.parallel-calls", { url: "/parallel-calls?intakePatientId" })
    .state("app.patients.intake.parallel-calls.profile", { url: "/:patientId", params: {
      patientId: null
      }
    })
    .state("app.patients.intake-flow", {
      url: "/patient-intake/flow/:patientId",
      component: WithAppInRouter(PatientIntakeFlowPage),
      params: {
        patientId: null
      }
    })
    .state("app.patients-compliance", {
        url: "/patients/compliance",
        component: WithAppInRouter(PatientComplianceRoute),
    })
    .state('app.addCaregiver', {
      url: "/add-caregiver",
      templateUrl: "admin/views/add-caregiver.html",
      data: {
        pageTitle: 'Add Caregiver'
      },
      controller: 'addCaregiverCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.trainingCenter', {
      url: "/training-center",
      template: '<div ui-view class="m-sm"></div>'
    })
    .state('app.trainingCenter.enrollmentsRequests', {
      url: "/enrollments-requests",
      templateUrl: "admin/views/training-center-enrollments-requests.html",
      data: {
        pageTitle: 'Enrollments Requests'
      },
      controller: 'trainingCenterEnrollmentsRequestsCtrl'
    })
    .state('app.trainingCenter.activeBundles', {
      url: "/active-bundles",
      templateUrl: "admin/views/training-center-active-bundles.html",
      data: {
        pageTitle: 'Active Bundles'
      },
      controller: 'trainingCenterActiveBundlesCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.trainingCenter.caregiversTrainingCenterOverview', {
      url: "/caregivers/training-center-overview",
      templateUrl: "admin/views/caregivers-training-center-overview.html",
      data: {
        pageTitle: 'Caregivers - Training Center Overview'
      },
      controller: 'CaregiversTrainingCenterOverview',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.trainingCenter.liveEvents', {
      url: "/live-events",
      templateUrl: "admin/views/training-center-live-events.html",
      data: {
        pageTitle: 'Live Events'
      },
      controller: 'trainingCenterLiveEventsCtrl'
    })

    .state('app.evv', {
      url: "/evv",
      template: '<div ui-view class="m-sm"></div>'
    })
    .state('app.evv.clockedVisits', {
      url: "/clockedVisits",
      templateUrl: "admin/views/clocked-visits.html",
      data: {
        pageTitle: 'Clock in & out'
      },
      controller: 'clockedVisitsCtrl'
    })
    .state('app.evv.clockedVisitsNew', {
      url: "/clockedVisitsNew",
      component: WithAppInRouter(ClockedVisitsGraphQLRoute),
      data: {
        pageTitle: 'Clock in & out (New)'
      }
    })
    .state('app.evv.devHelp', {
      url: "/dev-help",
      component: WithAppInRouter(EvvDevHelpDashboardRoute),
      data: {
        pageTitle: 'EVV Dev Help'
      }
    })
    .state('app.evv.dutyCodeMapping', {
      url: "/duty-code-mapping",
      component: WithAppInRouter(EvvDutyCodeMappingRoute),
      data: {
        pageTitle: 'EVV Duty Code Mapping'
      }
    })
    .state('app.evv.dutyCodeMapping.hhax', {
      url: "/hhax"
    })
    .state('app.payerHhaxPocMapping', {
      url: "/settings/payers/:payerId/hhax-poc-mapping",
      component: WithAppInRouter(PayerHhaxPocMappingRoute),
      data: {
        pageTitle: 'HHAeXchange POC Mapping'
      }
    })
    .state('app.evv.calls', {
      url: "/calls",
      templateUrl: "admin/views/calls.html",
      controller: 'callsCtrl'
    })
    .state('app.evv.calls.maintenance', {
      url: "/maintenance",
      templateUrl: "admin/views/calls-maintenance.html",
      controller: 'callsMaintenanceCtrl',
      resolve: {
        typeOfCalls: () => "unlinked"
      }
    })
    .state('app.evv.calls.rejected', {
      url: "/rejected",
      templateUrl: "admin/views/calls-maintenance.html",
      controller: 'callsMaintenanceCtrl',
      resolve: {
        typeOfCalls: () => "rejected"
      }
    })
    .state('app.payroll', {
      url: "/payroll",
      template: '<div ui-view class="m-sm"></div>'
    })
    .state('app.payroll.batches', {
      url: "/payrolls",
      templateUrl: "admin/views/billing-payrolls.html",
      controller: 'billingPayrollsCtrl'
    })
    .state('app.payroll.batch', {
      url: "/payrolls/:id",
      templateUrl: "admin/views/billing-payroll-details.html",
      data: {
        pageTitle: 'Payroll details'
      },
      controller: 'billingPayrollDetailsCtrl',
      params: {
        isDraft: false,
        payrollBatch: null,
        payrollBatchWithVisits: null
      }
    })
    .state('app.payroll.ptoApprovals', {
      url: "/ptoApprovals",
      templateUrl: "admin/views/pto-approvals.html",
      data: {
        pageTitle: 'PTO Approvals'
      },
      controller: 'ptoApprovalsCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state("app.payroll.verification", {
      url: "/payrollVerification/:id",
      component: WithAppInRouter(PayrollVerificationRoute),
      params: {
        id: null
      },
    })
    .state("app.payroll.audit", {
      url: "/payrollAudit/:id",
      component: WithAppInRouter(PayrollAuditRoute),
      params: {
        id: null
      },
    })
    .state('app.billing.payrolls', {
      url: "/payrolls",
      templateUrl: "admin/views/billing-payrolls.html",
      controller: 'billingPayrollsCtrl'
    })
    .state('app.visits', {
      url: "/visits",
      template: '<div ui-view class="m-sm"></div>'
    })
    .state('app.visits.dashboard', {
      url: "/dashboard",
      templateUrl: "admin/views/visits-dashboard.html",
      data: {
        pageTitle: 'Visits Dashboard',
        specialClass: 'visits-remove-intercom'
      },
      controller: 'visitsCtrl',
      resolve: {
        settings: function(DatabaseApi) {
          DatabaseApi.GetSettings();
          return true;
        }
      }
    })
    .state('app.visits.dashboard.item', {
        url: "/item?visitAssignmentId&broadcast&visitInstance&caregiver"
    })
    .state('app.visits.upload', {
      url: "/upload",
      templateUrl: "admin/views/visits-upload.html",
      data: {
        pageTitle: 'Upload Visits',
        specialClass: 'visits-remove-intercom'
      },
      controller: 'visitFileUploadCtrl',
    })
    .state('app.visits.broadcast', {
      url: "/broadcast",
      templateUrl: "admin/views/visits-broadcast.html",
      data: {
        pageTitle: 'Broadcast Open Visits'
      },
      controller: 'visitsBroadcastCtrl'
    })
    .state('app.visits.dailyNotes', {
      // `notesPatient` and `notesView` are the patient view: present means one patient's notes
      // (view: review | all | attestations), absent means the list of patients.
      //
      // Deliberately NOT called `patient`: the app opens the patient profile modal whenever
      // the URL carries a `?patient=` query parameter (see the $transitions.onSuccess handler
      // that watches for patient, caregiver, invoice, visitInstance and broadcast), so a
      // parameter by that name would open the profile over this page.
      //
      // The `notes*` filter params are how the Dashboard tab opens this list already filtered:
      // due, flagged, a priority, or a window of visit dates. They are read once when the list
      // opens and then belong to the list, so they are not rewritten as filters change.
      url: "/dailyNotes?{notesPatient:int}&{notesView}&{notesDue:bool}&{notesFlagged:bool}&{notesPriority}&{notesFrom}&{notesTo}&{notesAnyDate:bool}&{notesOffice:int}",
      params: {
        notesPatient: null,
        notesView: null,
        notesDue: null,
        notesFlagged: null,
        notesPriority: null,
        notesFrom: null,
        notesTo: null,
        notesAnyDate: null,
        notesOffice: null
      },
      data: {
        pageTitle: 'Daily Notes'
      },
      permissionKeys: ['view_visits_section_daily_notes'],
      component: WithAppInRouter(DailyNotesRoute)
    })
    // Kept as its own state rather than folded away: Page.Tabbed drives the tabs by
    // state name, so this is what makes the Attestations tab addressable and keeps
    // existing links to it working. It renders the same shell as its sibling.
    //
    // Reading is gated on the daily-notes view right, not on the co-signature right --
    // the second signature is an action inside the tab, not a condition of seeing it.
    //
    // The `attestations*` params are how the Dashboard's co-signature tiles open this tab
    // already filtered, read once when it opens, like the `notes*` params above.
    .state('app.visits.dailyNoteAttestations', {
      url: "/dailyNoteAttestations?{attestationsStatus}&{attestationsOffice:int}",
      params: {
        attestationsStatus: null,
        attestationsOffice: null
      },
      data: {
        pageTitle: 'Daily Note Attestations'
      },
      permissionKeys: ['view_visits_section_daily_notes'],
      component: WithAppInRouter(DailyNotesRoute)
    })
    // The Dashboard and Sync issues tabs. Named `dailyNoteOverview` / `dailyNoteSyncIssues` and
    // not `dailyNotesX`: Page.Tabbed picks a tab by state-name prefix, so a name starting with
    // `app.visits.dailyNotes` would be taken for the Daily notes tab.
    .state('app.visits.dailyNoteOverview', {
      url: "/dailyNoteOverview",
      data: {
        pageTitle: 'Daily Notes Dashboard'
      },
      permissionKeys: ['view_visits_section_daily_notes'],
      component: WithAppInRouter(DailyNotesRoute)
    })
    .state('app.visits.dailyNoteSyncIssues', {
      url: "/dailyNoteSyncIssues",
      data: {
        pageTitle: 'Daily Note Sync Issues'
      },
      permissionKeys: ['view_visits_section_daily_notes'],
      component: WithAppInRouter(DailyNotesRoute)
    })
    // Nurses' licenses, which decide who may sign daily notes. Named `dailyNoteLicenses` for
    // the same prefix reason as the states above.
    .state('app.visits.dailyNoteLicenses', {
      url: "/dailyNoteLicenses",
      data: {
        pageTitle: 'Daily Note Licenses'
      },
      permissionKeys: ['manage_daily_note_licenses'],
      component: WithAppInRouter(DailyNotesRoute)
    })
    .state('app.visitInstances', {
      url: "/visitInstances",
      templateUrl: "admin/views/visit-instances.html",
      data: {
        pageTitle: 'Visit instances'
      },
      controller: 'visitInstancesCtrl'
    })
    .state('app.dutySheets', {
      url: "/dutySheets",
      templateUrl: "admin/views/duty-sheets.html",
      data: {
        pageTitle: 'Duty Sheets'
      },
      controller: 'dutySheetsCtrl'
    })
    .state('app.dutySheetsApprovals', {
      url: "/timesheet-approval",
      templateUrl: "admin/views/e-time-sheet-approval.html",
      data: {
        pageTitle: 'Time Sheet Approval'
      },
      controller: 'eTimeSheetApprovalCtrl'
    })
    .state('app.staffingIssues', {
      url: "/staffing-issues",
      templateUrl: "admin/views/staffing-issues.html",
      data: {
        pageTitle: 'Staffing Issues'
      },
      controller: 'staffingIssuesCtrl'
    })
    .state('app.hoursUsage', {
      url: "/hours-usage",
      templateUrl: "admin/views/hours-usage.html",
      data: {
        pageTitle: "Hours Usage"
      },
      controller: "hoursUsageCtrl"
    })
    .state('app.billing', {
      url: "/billing",
      template: '<div ui-view class="m-sm"></div>'
    })
    .state('app.billing.visitsWithIssues', {
      url: "/visits-with-issues",
      templateUrl: "admin/views/billing-visits-with-issues.html",
      controller: 'billingVisitsWithIssuesCtrl'
    })
    .state('app.billing.invoices', {
      url: "/invoices",
      templateUrl: "admin/views/billing-invoices.html",
      controller: 'billingInvoicesCtrl',
      params: {
        batchId: null
      }
    })
    .state('app.billing.newInvoiceBatch', {
      url: "/new-invoice-batch",
      templateUrl: "admin/views/billing-new-invoice-batch.html",
      controller: 'billingNewInvoiceBatchCtrl'
    })
    .state('app.billing.invoice', {
      url: "/invoices/:id",
      templateUrl: "admin/views/billing-invoice-details.html",
      data: {
        pageTitle: 'Invoice'
      },
      controller: 'billingInvoiceDetailsCtrl',
      params: {
        id: null,
        invoice: null
      }
    })
    .state('app.billing.visitAdjustmentApprovals', {
      url: "/visit-adjustment-approvals",
      templateUrl: "admin/views/visit-adjustment-approvals.html",
      controller: 'billingVisitAdjustmentApprovalsCtrl'
    })
    // TEMP: Adjustment Approvals (New) route disabled until perf is solved
    // .state('app.billing.visitAdjustmentApprovalsNew', {
    //   url: "/visit-adjustment-approvals-new",
    //   component: WithAppInRouter(AdjustmentApprovalsNewRoute),
    //   data: {
    //     pageTitle: 'Adjustment Approvals (New)'
    //   }
    // })
    .state('app.billing.visitsToExport', {
      url: "/visits-to-export",
      templateUrl: "admin/views/billing-visits-to-export.html",
      controller: 'billingVisitsToExportCtrl'
    })
    .state('app.billing.invoicesToExport', {
      url: "/invoices-to-export",
      templateUrl: "admin/views/billing-invoices-to-export.html",
      controller: 'billingInvoicesToExportCtrl'
    })
    .state('app.billing.invoice.visit', {
      templateUrl: "admin/views/visit-instance-modal.html",
      data: {},
      controller: 'visitInstanceModalCtrl',
      params: {
        visit: {}
      }
    })
    .state('app.billing.exports', {
      url: "/exports",
      templateUrl: "admin/views/billing-exports.html",
      controller: 'billingExportsCtrl'
    })
    .state('app.billing.export', {
      url: "/exports/:id",
      templateUrl: "admin/views/billing-export-details.html",
      data: {
        pageTitle: 'Export details'
      },
      controller: 'billingExportDetailsCtrl',
      params: {
        id: null,
        export: null
      }
    })
    .state('app.billing.checks', {
      url: "/checks",
      templateUrl: "admin/views/billing-checks.html",
      controller: 'billingChecksCtrl'
    })
    .state('app.billing.check', {
      url: "/checks/:id",
      templateUrl: "admin/views/billing-check-details.html",
      data: {
        pageTitle: 'Check'
      },
      controller: 'billingCheckDetailsCtrl',
      params: {
        id: null,
        check: null
      }
    })
    .state('app.billing.uploadEdi', {
      url: "/upload-edi",
      templateUrl: "admin/views/file-uploader.html",
      controller: 'fileUploaderCtrl',
      params: {
        data: {}
      }
    })
    .state('app.billing.uploadArNotes', {
      url: "/upload-ar-notes",
      templateUrl: "admin/views/file-uploader.html",
      controller: 'fileUploaderCtrl',
      params: {
        data: {}
      }
    })
    .state('app.billing.claimsConversion', {
      url: "/claims-conversion",
      templateUrl: "admin/views/claims-conversion.html",
      controller: 'claimsConversionCtrl',
      params: {
        data: {}
      }
    })
    .state('app.billing.ediComparison', {
      url: "/edi-comparison",
      templateUrl: "admin/views/edi-comparison.html",
      controller: 'ediComparisonCtrl'
    })
    .state('app.billing.accountsReceivable', {
      url: "/accounts-receivable",
      templateUrl: "admin/views/billing-accounts-receivable.html",
      controller: 'billingAccountsReceivableCtrl'
    })
    .state('app.billing.surpluses',{
      url: "/surpluses",
      templateUrl: "admin/views/billing-surplus-dashboard.html",
      controller: 'billingPatientSurplusDashboardCtrl'

    })
    .state('app.visitEditRequests', {
      url: "/visit-edit-requests",
      templateUrl: "admin/views/visit-edit-requests.html",
      data: {
        pageTitle: 'Visit Edit Requests'
      },
      controller: 'visitEditRequestsCtrl'
    })
    // .state('app.payroll', {
    //     url: "/payroll",
    //     templateUrl: "admin/views/payroll.html",
    //     data: { pageTitle: 'Payroll' },
    //     controller: 'payrollCtrl'
    // })

    .state('app.analyticReports', {
      url: "/analyticReports",
      templateUrl: "admin/views/reports.html",
      data: {
        pageTitle: 'Reports'
      },
      controller: 'reportsCtrl'
    })
    .state('app.backOffice', {
      url: "/back-office",
      templateUrl: "admin/views/back-office.html",
      data: {
        pageTitle: 'Back Office'
      },
      controller: 'BackOfficeCtrl'
    })
    .state('app.settings', {
      url: "/settings",
      templateUrl: "admin/views/settings.html",
      data: {
        pageTitle: 'Settings'
      },
      controller: 'settingsCtrl'
    })
    .state("app.intakeFlowSettings", {
        url: "/settings/intake-flow",
        component: WithAppInRouter(PatientIntakeFlowSettingsRoute)
    })
    .state("app.intakeFlowSettings.visualizer", {
      url: "/visualizer",
    })
    .state('app.hrSettings', {
      url: "/hr-settings",
      templateUrl: "admin/views/hr-settings.html",
      data: {
        pageTitle: 'HR Settings'
      },
      controller: 'hrSettingsCtrl'
    })
    .state('app.notesSettings', {
      url: "/notes-settings",
      templateUrl: "admin/views/entity-notes/notes-settings.html",
      data: {
        pageTitle: 'Notes Settings'
      },
      controller: 'notesSettingsCtrl'
    })
    .state('app.trainingCenterSettings', {
      url: "/training-center-settings",
      templateUrl: "admin/views/training-center-settings.html",
      data: {
        pageTitle: 'Training Center Settings'
      },
      controller: 'TrainingCenterSettingsCtrl'
    })
    .state('app.trainingCenterExempts', {
      url: "/training-center-exempts",
      templateUrl: "admin/views/training-center-exempts.html",
      data: {
        pageTitle: 'Training Center Exempts'
      },
      controller: 'TrainingCenterExemptsCtrl'
    })
    .state('app.trainingCenterClassrooms', {
      url: "/training-center-settings-classrooms",
      templateUrl: "admin/views/training-center-classrooms.html",
      data: {
        pageTitle: 'Training Center Classrooms'
      },
      controller: 'trainingCenterClassroomsCtrl'
    })
    .state('app.trainingCenterClassroomsEdit', {
      url: "/training-center-settings-classrooms/:classroomId",
      templateUrl: "admin/views/training-center-classrooms-edit.html",
      data: {
        pageTitle: 'Training Center Classroom'
      },
      params: {
        classroomId: {
          squash: true,
          value: null
        },
      },
      controller: 'trainingCenterClassroomEditCtrl'
    })
    .state('app.trainingCenterBundleSettings', {
      url: "/training-center-settings/bundles/:id/:itemId",
      templateUrl: "admin/views/training-center-settings-bundle.html",
      data: {
        pageTitle: 'Training Center Settings'
      },
      params: {
        itemId: {
          squash: true,
          value: null
        },
      },
      controller: 'TrainingCenterBundleSettingsCtrl'
    })
    .state('app.trainingCenterBundleItemSettings', {
      url: "/training-center-settings/bundles/:bundleId/bundle_items/:bundleItemId",
      templateUrl: "admin/views/training-center-settings-bundle-item.html",
      data: {
        pageTitle: 'Training Center Settings'
      },
      controller: 'TrainingCenterBundleItemSettingsCtrl'
    })
    .state('app.trainingCenterMediaLibrary', {
      url: "./training-center/settings/media-library",
      templateUrl: "admin/views/training-center-media-library.html",
      data: {
        pageTitle: 'Media Library'
      },
      controller: 'TrainingCenterMediaLibraryCtrl'
    })
    .state('app.dashboard', {
      url: "/dashboard",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.dashboard.caregivers', {
      url: "/caregivers",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.dashboard.online', {
      url: "/online",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.dashboard.installations', {
      url: "/installations",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.dashboard.visitStatistics', {
      url: "/visitStatistics",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.dashboard.coordinatorActivity', {
      url: "/coordinatorActivity",
      templateUrl: "admin/views/dashboard.html",
      data: {
        pageTitle: 'Dashboard'
      },
      controller: 'dashboardCtrl'
    })
    .state('app.notes', {
      url: "/notes",
      templateUrl: "admin/views/notes-page.html",
      controller: 'notesCtrl',
      controllerAs: "notes",
      params: {
        tabName: null,
        noteId: null,
        mentionId: null
      }
    })
    .state('app.notes.report', {
      url: "/notes-report",
      templateUrl: "admin/views/notes-report.html",
      data: {
        pageTitle: 'Notes report'
      },
      controller: 'notesReportCtrl'
    })
    .state('app.notes.mentionsInbox', {
      url: "/mentions-inbox",
      templateUrl: "admin/views/agency-member-mentions-inbox.html",
      data: {
        pageTitle: 'Mentions Inbox'
      },
      controller: 'agencyMemberMentionsInboxCtrl',
      params: {
        noteId: null,
        mentionId: null
      }
    })
    .state('app.notes.mentionsDone', {
      url: "/mentions-done",
      templateUrl: "admin/views/agency-member-mentions-done.html",
      data: {
        pageTitle: 'Done Mentions'
      },
      controller: 'agencyMemberMentionsDoneCtrl'
    })
    .state('app.new-visit', {
      url: "/visits/new",
      templateUrl: "admin/views/new-visit.html",
      data: {
        pageTitle: 'New Visit'
      },
      controller: 'newVisitCtrl',
      resolve: {
        visit: function() {
          return true;
        },
        settings: function(DatabaseApi) {
          DatabaseApi.GetSettings();
          return true;
        }
      },
      params: {
        patient: {},
        contract: null,
        treatment: null,
        type: null,
      }
    })
    .state('app.single-visit', {
      url: "/visits/:id",
      templateUrl: "admin/views/new-visit.html",
      data: {
        pageTitle: 'Visit'
      },
      controller: 'newVisitCtrl',
      resolve: {
        visit: function(DatabaseApi, $stateParams) {
          return DatabaseApi.getVisit($stateParams.id);
        }
      },
      params: {
        patient: {},
      }
    })
    .state('app.visitDetailes', {
      url: "/visits/:id/details",
      templateUrl: "admin/views/visit-details.html",
      data: {
        pageTitle: 'Visit Details'
      },
      controller: 'visitDetailsCtrl',
      resolve: {
        visit: function(DatabaseApi, $stateParams) {
          return DatabaseApi.getVisit($stateParams.id);
        }
      },
      params: {
        visit: {}
      }
    })
    .state('app.visitAssignments', {
      url: "/visits/assignments",
      component: WithAppInRouter(VisitAssignmentsRoute),
    })
    .state('app.visitAssignments.assignment', {
        url: "/:visitAssignmentId?visitInstance&patient&caregiver&broadcast",
      })
    .state('app.patients.authorizedWithoutVisits', {
        url: "/authorized-without-visits",
        component: WithAppInRouter(AuthorizedPatientsWithoutVisitsRoute),
    })
    .state('app.patients.authorizedWithoutVisits.patient', {
        url: "?patient"
    })
    .state('app.patients.patientIssues', {
      url: "/patientIssues",
      component: WithAppInRouter(PatientIssuesRoute),
    })
    .state('app.patients.patientIssues.issue', {
      url: "/:id",
      params: {
        id: null
      }
    })
    .state('app.reports.cicoReports', {
      url: "/cico-reports",
      component: WithAppInRouter(CICOReportsRoute),
    })
    .state('app.patientDocumentBuilder', {
      url: "/patient-document-builder/:documentId",
      templateUrl: "admin/views/patient-document-builder.html",
      data: {
        pageTitle: 'Patient Document Builder',
        specialClass: 'no-intercom'
      },
      controller: 'patientDocumentBuilderCtrl'
    })
    .state('app.patientDocumentSettings', {
      url: "/patient-document-settings",
      templateUrl: "admin/views/patient-document-settings.html",
      data: {
        pageTitle: 'Patient Document Settings'
      },
      controller: 'patientDocumentSettingsCtrl'
    })
    .state('app.feed', {
      url: "/feed",
      templateUrl: "admin/views/feed.html",
      data: {
        pageTitle: 'Feed'
      },
      controller: 'feedCtrl'
    })
    .state('app.communication', {
      url: "/communication",
      templateUrl: "admin/views/communication.html",
      data: {
        pageTitle: 'Communication',
        specialClass: 'no-intercom'
      },
      params: {
        view: ''
      },
      controller: 'communicationCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.recruitment', {
      url: "/recruitment",
      templateUrl: "admin/views/recruitment.html",
      data: {
        pageTitle: 'Recruitment'
      },
      controller: 'recruitmentCtrl'
    })
    .state('app.passportVerifier', {
      url: "/passport-verifier",
      templateUrl: "admin/views/passport-verifier.html",
      data: {
        pageTitle: 'Passport Verifier '
      },
      controller: 'passportVerifierCtrl'
    })
    .state('app.passport', {
      url: "/passport",
      templateUrl: "admin/views/medflyt-passport.html",
      data: {
        pageTitle: 'Medflyt Passport'
      },
      controller: 'medflytPassportCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.globalSearch', {
      url: "/search-results",
      templateUrl: "admin/views/global-search-results.html",
      data: {
        pageTitle: 'Search'
      },
      params: {
        searchText: '',
        results: {
          patients: [],
          caregivers: [],
          visits: [],
          invoices: []
        },
        resultsPreview: []
      },
      controller: 'globalSearchCtrl'
    })
    .state('login', {
      url: "/login",
      data: {
        pageTitle: 'Login',
        specialClass: 'login-bg'
      },
      component: 'loginComponent'
    })
    .state('app.calendar', {
      url: "/calendar",
      templateUrl: "admin/views/test-calendar.html",
      controller: 'testCalendarCtrl'
    })
    .state('register', {
      url: "/register",
      templateUrl: "admin/views/register-v2.html",
      data: {
        pageTitle: 'Register',
        specialClass: 'login-bg'
      },
      controller: 'registerCtrl'
    })
    .state('forgot_password', {
      url: "/forgot_password",
      templateUrl: "admin/views/register.html",
      data: {
        pageTitle: 'Register',
        specialClass: 'login-bg'
      },
      controller: 'registerCtrl'
    })
    .state('app.flyers', {
      url: "/flyers",
      templateUrl: "admin/views/flyers.html",
      data: {
        pageTitle: 'Flyers'
      },
      controller: 'flyersCtrl'
    })
    .state('app.tutorials', {
      url: "/tutorials",
      templateUrl: "admin/views/tutorials.html",
      data: {
        pageTitle: 'Tutorials'
      },
      controller: 'tutorialsCtrl'
    })

    .state('app.reports', {
      url: "/reports",
      template: '<div ui-view></div>'
    })
    .state('app.reports.standard', {
      url: "/standard",
      templateUrl:'admin/views/standard-reports.html',
      data: {
        pageTitle: 'Standard reports'
      },
      controller: 'standardReportsCtrl'
    })
    .state('app.reports.standard.standardReportView', {
      url: "/:standardReportId/standard-report-view",
      templateUrl:'admin/views/standard-report-view.html',
      resolve: {
        report: function(reportService, $stateParams) {
            return reportService.getStandardReport($stateParams.standardReportId);
        }
      },
      controller: 'standardReportViewCtrl'
    })
    .state('app.reports.coronaVirusReports', {
      url: "/corona-virus-reports",
      templateUrl: "admin/views/corona-virus-reports.html",
      data: {
        pageTitle: 'COVID-19 Reports'
      },
      controller: 'coronaVirusReportsCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.reports.savedReports', {
      url: "/saved-reports",
      templateUrl: "admin/views/saved-reports.html",
      data: {
        pageTitle: 'Saved reports'
      },
      controller: 'savedReportsCtrl'
    })
    .state('app.reports.savedReports.my', {
      url: "/my-saved-reports",
      templateUrl: "admin/views/my-saved-reports.html",
      data: {
        pageTitle: 'My reports'
      },
      controller: 'mySavedReportsCtrl'
    })
    .state('app.reports.savedReports.shared', {
      url: "/shared-saved-reports",
      templateUrl: "admin/views/shared-saved-reports.html",
      data: {
        pageTitle: 'Shared reports'
      },
      controller: 'sharedSavedReportsCtrl'
    })
    .state('app.reports.reportTool', {
      url: "/report-tool",
      templateUrl: "admin/views/main-report-tool.html",
      data: {
        pageTitle: 'Report tool'
      },
      controller: 'reportToolMain',
      params: {
        savedReportId: null,
        accessType: null,
        mySavedReportsNames: null
      }
    })

    // AGENCIES
    .state('app.agencies', {
      url: "/agencies",
      template: '<div ui-view class="m-t-sm"></div>'
    })
    .state('app.agencies.customerEngagement', {
      url: "/customer-engagement",
      templateUrl: "admin/views/customer-engagement.html",
      controller: 'customerEngagementCtrl'
    })
    .state('app.agencies.engagementKpi', {
      url: "/engagement-kpi",
      templateUrl: "admin/views/engagement-kpi.html",
      controller: 'engagementKPICtrl'
    })
    .state('app.hhax', {
      url: "/hhax-integration",
      template: '<div ui-view class="m-t-sm"></div>',
    })
    .state('app.hhax.billing', {
      url: "/billing",
      templateUrl: "admin/views/hha-integration/hha-integration-billing.html",
      data: {
        pageTitle: 'HHAX Billing Integration'
      },
      controller: 'hhaIntegrationBillingCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.hhax.nonBilling', {
      url: "/non-billing",
      templateUrl: "admin/views/hha-integration/hha-integration-non-billing.html",
      data: {
        pageTitle: 'HHAX Non Billing Integration'
      },
      controller: 'hhaIntegrationNonBillingCtrl',
      resolve: {
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        }
      }
    })
    .state('app.hhax.unlinkedPatients', {
      url: "/unlinked-patients",
      templateUrl: "admin/views/hha-integration/hha-integration-unlinked-patients.html",
      data: {
        pageTitle: 'HHAX Integration - Unlinked Patients'
      },
      controller: 'hhaIntegrationUnlinkedPatientsCtrl'
    })
    .state('app.complianceDocumentReview', {
      url: "/compliance-document-review",
      template: '<div ui-view class="m-t-sm"></div>',
    })
    .state('app.complianceDocumentReview.complianceDocumentReview', {
      url: "/compliance-document-review",
      data: {
        pageTitle: 'Compliance Document Review'
      },
      component: ComplianceDocumentReviewScreenComponent.$name
    })
    .state("app.commcenter", {
        url: "/commcenter",
        component: WithAppInRouter(OpenCommunicationsRoute),
    })
    .state("app.commcenter_ticket", {
      url: "/commcenter/:ticketId",
      component: WithAppInRouter(CommunicationCenterTicketRoute),
      params: {
        ticketId: null
      },
    })
    .state("app.workflow_tasks", {
        url: "/workflow-tasks",
        component: WithAppInRouter(WorkflowTasksRoute),
    })
    .state("app.workflow_tasks.task", {
        url: "/:id",
        params: {
            id: null
        }
    })
    .state("app.workflow_tasks.task.intake", {
      url: "/:id?{intakePatient:int}",
      params: {
        id: null,
        intakePatient: null
      }
  })
    .state("app.workflow_task_viewer", {
        url: "/workflow-task-viewer",
        component: WithAppInRouter(WorkflowTaskViewerRoute),
    })
    .state("app.workflow_task_viewer.intake", {
        url: "?{intakePatient:int}",
        params: {
            intakePatient: null
        }
    })
    .state("app.workflow_task_viewer.broadcast", {
        url: "?{broadcast:int}",
        params: {
            broadcast: null
        }
    })
    .state("app.workflow_skills", {
        url: "/workflow-skills",
        component: WithAppInRouter(WorkflowSkillsRoute),
    })
    .state("app.workflow_skills.assign", {
      url: "/assign"
    })
    .state("app.workflow_skills.assign.to", {
      url: "/:id",
      params: {
        id: null
      }
    })
    .state("app.faxes", {
      url: "/faxes",
      component: WithAppInRouter(OpenFaxDashboardRoute),
    })
    .state("app.caregiver_supplies_shipments", {
      url: "/caregiver-supplies-shipments",
      component: WithAppInRouter(CaregiverSuppliesShipmentsRoute),
    })
    .state("app.administrative_payment", {
      url: "/administrative_payment",
      component: WithAppInRouter(AdministrativePaymentRoute),
    })
    .state("app.administrative_payment.invoicing", {
      url: "/invoicing"
    })
    .state("app.administrative_payment.claims", {
      url: "/claims"
    })
    .state("app.banked_minutes", {
      url: "/banked_minutes",
      component: WithAppInRouter(BankedMinutesRoute),
    })
    .state("app.banked_minutes.view", {
      url: "/view"
    })
    .state("app.banked_minutes.jobs", {
      url: "/jobs"
    })
    .state("app.authorization_utilization", {
      url: "/authorization_utilization",
      data: {
        pageTitle: "Authorization Utilization"
      },
      component: WithAppInRouter(AuthorizationUtilizationRoute),
    })
    .state("app.authorization_utilization.dashboard", {
      url: "/dashboard"
    })
    .state("app.authorization_utilization.patients", {
      url: "/patients"
    })
    .state("app.uploads", {
      url: "/uploads",
      component: WithAppInRouter(UploadsRoute),
    })
    .state("app.uploads.list", {
      url: "/list"
    })
    .state("app.uploads.arNotes", { url: "/ar-notes" })
    .state("app.uploads.authorization", {
      url: "/authorization"
    })
    .state("app.caregivers_hcr_compliance", {
        url: "/state-compliance/hcr",
        component: WithAppInRouter(CaregiverHcrStateComplianceRoute),
    })
    .state("app.caregivers_chrc_compliance", {
        url: "/state-compliance/chrc",
        component: WithAppInRouter(CaregiverChrcStateComplianceRoute),
    })
    .state("app.caregivers_state_compliance_issues", {
        url: "/state-compliance/issues",
        component: WithAppInRouter(CaregiverStateComplianceIssuesPage),
    });
    ;

  // The AngularJS caregivers page. Registered only while the memory improvements
  // are off - its `pros` resolve pulls every caregiver in the agency into the
  // browser, which is what the improvements exist to stop.
  if (!useCaregiverMemoryImprovements) {
    $stateProvider
      .state('app.professionals', {
        url: "/professionals",
        templateUrl: "admin/views/professionals.html",
        data: {
          pageTitle: 'Professionals'
        },
        controller: 'professionalsCtrl',
        resolve: {
          pros: function(DatabaseApi) {
            return DatabaseApi.caregivers();
          },
          offices: function($rootScope, officesService) {
            if (!officesService.offices) {
              return officesService.getOffices();
            } else {
              return officesService.offices;
            }
          }
        }
      })
      .state('app.professionals.caregivers', {
        url: "/caregivers",
        data: {
          pageTitle: 'Caregivers'
        },
      })
      .state('app.professionals.caregivers.profile', {
        url: "/caregivers?{caregiver:int}",
        templateUrl: "admin/views/professionals.html",
        data: { pageTitle: 'Caregivers' },
        controller: 'professionalsCtrl',
        permissionKeys: ['view_caregiver_profile'],
      })
      .state('app.professionals.pendingAcceptance', {
        url: "/pendingAcceptance",
        templateUrl: "admin/views/professionals.html",
        data: {
          pageTitle: 'Pending Acceptance'
        },
        controller: 'professionalsCtrl',
        resolve: {
          pros: function(DatabaseApi) {
            return DatabaseApi.caregivers();
          }
        }
      });
  }

  var filterAliasUrls = {
    "confirmed": "admin/views/common/confirmed.html",
    "orientation": "admin/views/common/orientation.html",
    // note: ngTable also registers a 'number' filter
    // we're overriding this alias to point to our custom template
    //"number": "path/to/your/filters/number.html"
  };
  ngTableFilterConfigProvider.setConfig({
    aliasUrls: filterAliasUrls
  });

  LightboxProvider.fullScreenMode = true;


}

export const uibModalProviderConfig = [
  "$uibModalProvider",
  function ($uibModalProvider) {
    $uibModalProvider.options.backdrop = "static";
  },
];

export const compileProviderConfig = [
  "$compileProvider",
  function ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(file|http|https|ftp|mailto|tel|app|blob):/);
    $compileProvider.imgSrcSanitizationWhitelist(
      /^\s*(https?|local|data|chrome-extension|blob|data):/
    );
  },
];

/* @ngInject */
export function initialRun($rootScope, $state, DatabaseApi, editableOptions, Storage, Notifications, $window, $timeout, Socket, Analytics, toaster, $uibModal, VisitStatus, SweetAlert, $location, Consts, agencyMemberMentionsService, $transitions, wildcard, noteConsts, dropdownSettingsConsts, reactAdapterService, caregiverLookupService, patientLookupService, $q) {
  const preLoginStates = ['login', 'register', 'forgot_password'];

  // Perf: when the first load deep-links straight into a patient/caregiver modal,
  // don't render the main ui-view (the dashboard behind the modal) until the
  // modal is closed once. After that first close the main view renders and stays
  // (suppressMainView is only ever set true here, at bootstrap).
  //
  // Both optimizations below are scoped to the beta window. They were measured
  // against it and trade a slower navbar/dashboard for a faster modal, so the
  // legacy window keeps the unmodified startup it has always had.
  const isDeepLinkedIntoEntityModal = !!(
    getParameterByName('patient') || getParameterByName('caregiver')
  );

  $rootScope.suppressMainView = isDeepLinkedIntoEntityModal && isBetaProfileWindowEnabled();

  // Perf: on that same deep-link criterion, also defer the two navbar-badge
  // fetches — unread mentions and chat rooms. Both only feed the notifications
  // bell in the top right, so nothing the user is looking at needs them while the
  // modal boots, and both otherwise compete with the modal's own 8 requests for a
  // single-threaded server. Released by markEntityModalContentReady() (or by the
  // modal closing, whichever happens first); the bell shows a spinner until then.
  $rootScope.deferNavbarBadges = $rootScope.suppressMainView;
  $rootScope.navbarBadgesLoading = $rootScope.deferNavbarBadges;

  // The spinner is driven by a body class and pure CSS rather than an ng-if, on
  // purpose. Binding it to a $rootScope flag left the spinner on screen for
  // seconds after the flag had already flipped: during startup this app's digests
  // are contended enough that neither a direct assignment, $evalAsync, nor
  // $applyAsync got the ng-if re-evaluated promptly (measured 3.3s late). A class
  // toggle needs no digest at all.
  const NAVBAR_BADGES_LOADING_CLASS = 'navbar-badges-loading';

  const setNavbarBadgeSpinner = function(visible) {
    if (document.body === null) {
      return;
    }

    document.body.classList.toggle(NAVBAR_BADGES_LOADING_CLASS, visible);
  };

  setNavbarBadgeSpinner($rootScope.deferNavbarBadges);

  // The pending-acceptance badge is a separate case: its count only exists once
  // GET /caregivers_pending responds (db.js sets $rootScope.pendingCaregivers
  // there). That request is *not* deferred — deferring it would also defer the
  // caregivers dictionary it populates — it simply isn't instant, so the badge
  // spins until the number is real. db.js clears this on both the success and
  // error paths.
  $rootScope.setPendingBadgeLoading = function(visible) {
    if (document.body === null) {
      return;
    }

    document.body.classList.toggle('navbar-pending-loading', visible);
  };

  $rootScope.setPendingBadgeLoading(true);

  const deferredNavbarBadgeLoaders = [];

  /**
   * Runs `loader` now, or queues it until the deep-linked modal is ready.
   * `loader` may return a promise; that is used only to clear the spinner.
   */
  $rootScope.whenNavbarBadgesReady = function(loader) {
    if ($rootScope.deferNavbarBadges) {
      deferredNavbarBadgeLoaders.push(loader);
      return;
    }

    loader();
  };

  $rootScope.flushNavbarBadges = function() {
    $rootScope.deferNavbarBadges = false;

    const loaders = deferredNavbarBadgeLoaders.splice(0, deferredNavbarBadgeLoaders.length);

    const stopSpinner = function() {
      // Keep the scope flag in step for any other consumer; no digest required.
      $rootScope.navbarBadgesLoading = false;
      // Class toggle — this is what the user sees, and it is immediate.
      setNavbarBadgeSpinner(false);
    };

    if (loaders.length === 0) {
      stopSpinner();
      return;
    }

    let pending = loaders.length;
    const settle = function() {
      pending--;
      if (pending === 0) {
        stopSpinner();
      }
    };

    loaders.forEach(function(loader) {
      let result = null;

      try {
        result = loader();
      } catch (err) {
        console.error('Deferred navbar badge loader failed', err);
      }

      if (result && typeof result.finally === 'function') {
        result.finally(settle);
      } else {
        settle();
      }
    });
  };

    $transitions.onBefore({} , function(transition) {
        const permissionsKeys = transition.to().permissionKeys;
        const stateService = transition.router.stateService;
        if (permissionsKeys && !permissionsKeys.some(key => $rootScope.isPermittedByKey(key))) {
            return stateService.target('app.dashboard');
        }
    })

    /*
     * Pages that have not been rebuilt for the caregiver memory improvements.
     *
     * They are built around loading every caregiver in the agency, which is the
     * thing the improvements remove. Left reachable they would render against
     * data that path no longer produces - plausible numbers that are quietly
     * wrong, which is worse than a page that does not open.
     *
     * Blocked at the transition rather than inside each controller so the
     * address bar never moves and there is one list to delete when they are
     * rebuilt.
     */
    const STATES_WITHOUT_MEMORY_IMPROVEMENTS = {
        'app.caregiversCompliance': 'Compliance',
        'app.reports.coronaVirusReports': 'The COVID report',
        'app.analyticReports': 'Reports'
    };

    $transitions.onBefore({}, function (transition) {
        const name = transition.to().name;
        const label = STATES_WITHOUT_MEMORY_IMPROVEMENTS[name];

        if (label === undefined || !isCaregiverMemoryImprovementsEnabled()) {
            return;
        }

        // Deferred, not popped here. On a direct navigation or a refresh this
        // hook runs before the shell exists, so the toaster has nowhere to put
        // a toast and it is silently dropped - which is how this first shipped,
        // redirecting with no explanation at all.
        $timeout(function () {
            toaster.pop(
                'warning',
                label + ' is unavailable',
                'It has not been rebuilt for the caregiver memory improvements. Turn that ' +
                    'beta feature off in Settings to use this page.'
            );
        }, 600);

        // Redirected rather than cancelled. Cancelling looks right when the
        // click came from inside the app, but these URLs are also opened
        // directly and refreshed - and cancelling the *initial* transition
        // leaves the router with no state to render, which is a white screen.
        // The toast is what tells the user this was deliberate.
        return transition.router.stateService.target('app.dashboard');
    })

    // $transitions.onSuccess({} , function(transition) {
    //   if(preLoginStates.indexOf(transition.to().name) !== -1) {
    //     try {
    //       window.HubSpotConversations.widget.remove();
    //     } catch (e) {

    //     }

    //   } else {

    //     try {
    //       window.HubSpotConversations.widget.load({ widgetOpen: false });
    //     } catch (e) {

    //     }

    //   }
    // })

  var bell = new Audio('../admin/sounds/bell.mp3');
  $rootScope.comingSoon = function() {
    toaster.pop('success', 'Coming soon...');
  }
  $rootScope.commPageChatCounterCache = {};
  /*
    for(var i = 0 ; i < 100 ; i++){
      $http.get('https://medflytserver-stg.herokuapp.com/').then(function (v) {
          console.log(new Date());
        }, function (err) {
          console.log(err)
        });
    }
    */

  $rootScope.showCallsDashboardAgencies = [
    7,
    4093,
    3235,
    5149,
    5215,
    4621,
    1057,
    5182,
    5678,
    6040,
    2806,
    5644,
    6205,
    6238,
    5974,
    4357,
    6634,
    4489
  ];
  $rootScope.allLanguages = [
    'English',
    'Spanish',
    'Russian',
    'Chinese',
    'French',
    'Arabic',
    'Creole'
  ];
  $rootScope.allLanguagesIdLabel = [{
      id: 1,
      label: "English"
    },
    {
      id: 2,
      label: "Spanish"
    },
    {
      id: 3,
      label: "Chinese"
    },
    {
      id: 4,
      label: "Portuguese"
    },
    {
      id: 5,
      label: "French"
    },
    {
      id: 6,
      label: "Russian"
    },
    {
      id: 7,
      label: "Arabic"
    },
  ];

  $rootScope.singleDropdownExtraSettings = {
    showCheckAll: false
  };

  $rootScope.boostCoronavirusModal = function() {

    var PRICE_PER_SMS = Math.ceil(Consts.SEGMENT_AMOUNT * Consts.PRICE_PER_SEGMENT);
    Analytics.event("Boost clicked", {
      type: "DOWNLOAD_BOOST"
    });

    if ($rootScope.stats.caregivers === undefined) {
      return;
    }

    const activeCaregiverIds = $rootScope.stats.caregivers.ids.active;

    var modalInstance = $uibModal.open({
      templateUrl: 'admin/views/boost-modal.html',
      size: 'lg',
      controller: 'boostModalCtrl',
      resolve: {
        textAmountToBroadcast: function() {
          return activeCaregiverIds.length
        },
        priceOverallCents: function() {
          return activeCaregiverIds.length * PRICE_PER_SMS
        },
        type: function() {
          return "CORONAVIRUS_BOOST"
        }
      },
      windowTopClass: "boost-modal"
    });
    modalInstance.result.then(function(res) {
      if (res === "BOOST") {
        DatabaseApi.post('agency/' + $rootScope.agencyId + '/' + $rootScope.agencyMemberId + '/boost', {
          caregiverIds: activeCaregiverIds,
          price: PRICE_PER_SMS,
          type: "CORONAVIRUS_BOOST",
          visit: null
        }).then(function(result) {
          Analytics.event("Boost done", {
            type: "CORONAVIRUS_BOOST",
            pricePerSms: PRICE_PER_SMS
          });
          toaster.pop('success', 'Boosted successfully', 'Allow 10 minutes for sms to be sent');
        }).catch(function(err) {
          toaster.pop('error', 'Boost failed', err.data.error ? err.data.error : 'Please try again.');
        });
      }
    });
  };



  //$rootScope.pendingVisitEditRequests = 10;
  // $rootScope.showSweepStakes = !Storage.get('hide-sweep-vegas');

  $rootScope.totalNewChats = 0;
  $rootScope.visitSettings = {
    single: {},
    recuring: {}
  };


  $rootScope.setCompanyType = function(companyType) {
    if (companyType === 'Hospice' || companyType === 'SNF' || companyType === 'HOS') {
      $rootScope.companyType = 'staffing';
    } else if (!companyType || companyType === 'undefined' || companyType === 'CHHA' || companyType === 'CHH' || companyType === 'LHCSA') {
      ////console.log('home care');
      $rootScope.companyType = 'homeCare';
    } else {
      $rootScope.companyType = 'MLTC(P)';
    }
    Storage.set('company-type', companyType);
  };

  var comapnyT = Storage.set('company-type');
  $rootScope.setCompanyType(comapnyT);


  editableOptions.theme = 'bs3';
  /*
   if($rootScope.user && $rootScope.user._id){
   DatabaseApi.connect();
   }
   */



  $rootScope.stealthMode = Storage.get('stealthMode') || false;
  var userObject = Storage.getObject('user');
  if (
    angular.isDefined(userObject.authToken) &&
    (
      !$rootScope.user ||
      !$rootScope.user.email ||
      !$rootScope.user.verified
    ) &&
    (
      (
        $rootScope.user &&
        $rootScope.user.superuser
      ) ||
      userObject.superuser ||
      userObject.agencyMember.pocPermissions !== undefined
    )
  ) {

    $rootScope.token = userObject.authToken;
    $rootScope.refreshToken = userObject.refreshToken;
    $rootScope.loginType = userObject.loginType;
    $rootScope.userId = userObject.userId;
    if (userObject.agency) {
      $rootScope.agencyId = userObject.agency.id;
    }
    if (userObject.agencyMember) {

      // userObject = userObject.loginData.agency;
      // userObject = userObject.loginData.agencyMember;
      // userObject = userObject.loginData.coordinator;
      // userObject = userObject.loginData.type;

      $rootScope.agencyMemberId = userObject.agencyMember.id;
    }

    $rootScope.user = userObject;



    $rootScope.user.verified = true;
    if (userObject.agencyMember) {
      $rootScope.user.displayName = $rootScope.user.agencyMember.firstName + ' ' + $rootScope.user.agencyMember.lastName;
    }
    $rootScope.setCompanyType(userObject.organizationType);
    $rootScope.user.email = Storage.get('userEmail');

    if ($rootScope.user.superuser) {
      $rootScope.user.admin = true;
    } else if (userObject.agencyMember) {
      if (userObject.agencyMember.jobTitle === 'Admin') $rootScope.user.admin = true;
    }

    if ($rootScope.agencyId !== undefined && $rootScope.agencyMemberId !== undefined) {
      $rootScope.whenNavbarBadgesReady(() => agencyMemberMentionsService.getInboxUnread().then((res) => {
        $rootScope.mentionesCount = res.data.unread.length;
      }));
    }

    if (import.meta.env.PROD && $rootScope.agencyMemberId) {
        const logrocketSettingsUrl = wildcard(
          'agencies/:agencyId/agency_members/:agencyMemberId/logrocket_settings',
          $rootScope.agencyId,
          $rootScope.agencyMemberId
        );
        DatabaseApi.get(logrocketSettingsUrl).then((res) => {
          if (res.data.shouldInitLogRocket) {
            logrocket.init({
                agencyMember: $rootScope.user.agencyMember,
                userId: $rootScope.user.userId,
            });
          }
        });
    }


    Socket.init(userObject);
    DatabaseApi.connect();

    console.log(`[react-adapter-service] init`);
    reactAdapterService.init();
  }

  // if($rootScope.agencyId !== 62) $rootScope.showSweepStakes = false;
  $rootScope.showSweepStakes = false;

  window.addEventListener('popstate', function() {
    setTimeout(() => {
      const caregiverParam = getParameterByName('caregiver');
      // Re-open the modal in case of pop state with query param
      if (caregiverParam) {
        $rootScope.handleOpenCaregiverModal(caregiverParam);
      } else {
        // Close the modal in case of pop state with no query param
        $rootScope.closeCaregiverModal();
      }

      const patientParam = getParameterByName('patient');
      // Re-open the modal in case of pop state with query param
      if (patientParam) {
        $rootScope.handleOpenPatientModal(patientParam);
      } else {
        // Close the modal in case of pop state with no query param
        $rootScope.closePatientModal();
      }

      const invoiceParam = getParameterByName('invoice');
      // Re-open the modal in case of pop state with query param
      if (invoiceParam) {
        $rootScope.handleOpenInvoiceModal({ invoiceId: invoiceParam });
      } else {
        // Close the modal in case of pop state with no query param
        $rootScope.closeInvoiceModal();
      }

      const visitInstanceParam = getParameterByName('visitInstance');
      // Re-open the modal in case of pop state with query param
      if (visitInstanceParam) {
        $rootScope.handleOpenVisitInstanceModal(visitInstanceParam, getParameterByName('visitInstancePatient') || null);
      } else {
        // Close the modal in case of pop state with no query param
        $rootScope.closeVisitInstanceModal();
      }

      const visitBroadcastParam = getParameterByName('broadcast');
      // Re-open the modal in case of pop state with query param
      if (visitBroadcastParam) {
        $rootScope.handleOpenVisitBroadcastModal(visitBroadcastParam);
      } else {
        // Close the modal in case of pop state with no query param
        $rootScope.closeVisitBroadcastModal();
      }
    }, 200);
  });

  $transitions.onStart({}, function(trans) {
    const toState = trans.$to();
    if ($rootScope.activeChat) $rootScope.closeChat();

    Analytics.pageView(toState.name);

    if ((!$rootScope.user || !$rootScope.user.email || !$rootScope.user.verified) && preLoginStates.indexOf(toState.name) === -1) {
      $state.go('login');
    } else if ($rootScope.user && $rootScope.user.email && preLoginStates.indexOf(toState.name) !== -1) {
      if (!$rootScope.stats) init();
      $state.go('app.dashboard');
    } else {
      if (!$rootScope.stats && $rootScope.user && $rootScope.user.email) init();
    }
  });

  // Open/close modals based on URL query params. This previously lived inside
  // onStart wrapped in a 200ms setTimeout, which merely guessed at when the
  // transition/view would be ready. onSuccess is the correct hook — it fires
  // once the transition has completed and target views are resolved — so we can
  // open the modal immediately with no artificial delay on the critical path.
  //
  // The params MUST be read off $location, not window.location: ui-router hands
  // the new URL to $location during the transition, but AngularJS only flushes
  // $location to the browser at the end of the digest, i.e. *after* these hooks
  // run. window.location still holds the URL we came from here, so sniffing it
  // reads the previous page's params — it would close the modal the transition
  // was opening and re-open the one it was leaving (the 200ms setTimeout used to
  // hide this by running long after the flush).
  $transitions.onSuccess({}, function() {
    const url = $location.absUrl();

    // Open caregiver modal when URL conatins query param
    const caregiverParam = getParameterByName('caregiver', url);
    if (caregiverParam) {
      $rootScope.handleOpenCaregiverModal(caregiverParam);
    }

    // Open patient modal when URL conatins query param
    const patientParam = getParameterByName('patient', url);
    if (patientParam) {
      $rootScope.handleOpenPatientModal(patientParam);
    } else {
      // Close the modal in case of pop state with no query param
      if (!$rootScope.allowPatientModalWithoutQueryParam) {
        $rootScope.closePatientModal();
      }
    }

    const invoiceParam = getParameterByName('invoice', url);
    // Re-open the modal in case of pop state with query param
    if (invoiceParam) {
      $rootScope.handleOpenInvoiceModal({ invoiceId: invoiceParam });
    } else {
      // Close the modal in case of pop state with no query param
      $rootScope.closeInvoiceModal();
    }

    const visitInstanceParam = getParameterByName('visitInstance', url);
    // Re-open the modal in case of pop state with query param
    if (visitInstanceParam) {
      $rootScope.handleOpenVisitInstanceModal(visitInstanceParam, getParameterByName('visitInstancePatient', url) || null);
    } else {
      // Close the modal in case of pop state with no query param
      if (!$rootScope.allowVisitInstanceModalWithoutQueryParam) {
        $rootScope.closeVisitInstanceModal();
      }
    }

    const visitBroadcastParam = getParameterByName('broadcast', url);
    // Re-open the modal in case of pop state with query param
    if (visitBroadcastParam) {
      $rootScope.handleOpenVisitBroadcastModal(visitBroadcastParam);
    } else {
      // Close the modal in case of pop state with no query param
      $rootScope.closeVisitBroadcastModal();
    }
  });

  $transitions.onError({}, function(trans) {
    console.error(trans.error());
  });

  $rootScope.$state = $state;


  $rootScope.isHr = function() {
    if (!$rootScope.user || !$rootScope.user.agencyMember || !$rootScope.user.agencyMember.jobTitle || $rootScope.user.agencyMember.jobTitle === 'Admin') {
      if (!$rootScope.user || !$rootScope.user.agencyMember) return false;
      if ($rootScope.user.agencyMember.jobTitle === 'Admin') return false;
      if ($rootScope.user.agencyMember && $rootScope.user.agencyMember.jobTitle === 'HR') return true;
    } else if ($rootScope.user.agencyMember.jobTitle === 'HR') return true;
    return false;
  };

  $rootScope.showViewByUserRole = function(view) {
    //if(role === 'Admin') return true;

    var role;

    if (!$rootScope.user) return false;
    if ($rootScope.user.superuser) return true;

    if (!$rootScope.user.agencyMember || !$rootScope.user.agencyMember.jobTitle || $rootScope.user.agencyMember.jobTitle === 'Admin') {
      if ($rootScope.user.agencyMember && $rootScope.user.agencyMember.jobTitle === 'Admin') return true;
    } else {
      role = $rootScope.user.agencyMember ? $rootScope.user.agencyMember.jobTitle : false;
    }


    if (role === 'HR') {
      if (view === 'visits') return false;
      if (view === 'confirmation') return false;
      if (view === 'payroll') return false;
      if (view === 'reports') return false;
      if (view === 'export-filters') return false;
      return true;

    } else if (role === 'Coordinator' || role === 'SeniorCoordinator') {
      if (view === 'payroll') return false;
      if (view === 'downloadBar') return false;
      if (view === 'reports') return false;
      //if (view === 'doc-expirations') return false;
      if (view === 'hrSettings') return false;
      if (view === 'notesSettings') return false;
      if (view === 'hrPendingApplication') return false;
      if (view === 'pending') return role === 'SeniorCoordinator';
      if (view === 'export-filters') return false;
      if (view === 'recruitment') return false;

      return true;
    }

    return false;
  };


  function init() {

    $rootScope.pendingCaregivers = DatabaseApi.getPendingCaregivers();
    //console.log($rootScope.pendingCaregivers);
    $rootScope.stats = {
      pending: 0,
      changes: 0,
      newCareGivers: 0,
      paymentsWaiting: 0,
      hrPapers: 0,
      scheduled: 0,
      waiting: 0,
      confirmed: 0,
      completed: 0,
      canceled: 0
    };

    // Cache-warming call whose return value is unused — the side effect is the
    // chat_rooms fetch, so defer it with the other navbar-badge requests. (The
    // getter is also reached from connect(); db.js guards against a double fetch.)
    $rootScope.whenNavbarBadgesReady(() => DatabaseApi.chats());

    $rootScope.caregiversPendingApplication = DatabaseApi.getCaregiversPendingApplication();
  }

  // Prefer the display records shipped with chats and visits. Search is only
  // needed for ids introduced later, such as a newly received chat.
  function resolveCaregiverById(id, onFound, onMissing) {
    if (!id) return;
    if ($rootScope.pendingCaregivers) {
      var pending = $rootScope.pendingCaregivers.find(function(g) { return g.id === id; });
      if (pending) {
        onFound(pending);
        return;
      }
    }
    const display = DatabaseApi.getCaregiverDisplayById(id);
    if (display) {
      onFound(display);
      return;
    }
    caregiverLookupService.byId(id).then(function(caregiver) {
      if (caregiver !== null) onFound(caregiver);
      else if (onMissing) onMissing();
    });
  }

  function resolveChatCaregiverName(chat, onFound) {
    if (chat.caregiverName) {
      onFound(chat.caregiverName);
      return;
    }
    if (chat.caregiverLookupRetryAt > Date.now()) return;
    // The existing lookup service already shares requests that are in flight.
    resolveCaregiverById(chat.chatRoomType.caregiverId, function(caregiver) {
      chat.caregiverName = caregiverDisplayName(caregiver);
      delete chat.caregiverLookupRetryAt;
      onFound(chat.caregiverName);
    }, function() {
      // Retry missing caregivers later instead of on every presence event.
      chat.caregiverLookupRetryAt = Date.now() + 60_000;
    });
  }

  // The dictionary's entries carried an assembled `displayName`; a caregiver
  // resolved by id carries the name parts, so it is assembled here instead.
  function caregiverDisplayName(caregiver) {
    if (caregiver.displayName) return caregiver.displayName;
    return [caregiver.firstName, caregiver.middleName, caregiver.lastName]
      .filter(function(part) { return part !== null && part !== undefined && part !== ''; })
      .join(' ');
  }

  var notificationsActive = false;

  function preSetVisits(push, caregiversRefresh) {

    if (!$rootScope.stats) return;

    if ($rootScope.activeChat && $rootScope.activeChat.caregiver) {
      resolveCaregiverById($rootScope.activeChat.caregiver, function(caregiver) {
        $rootScope.activeChat.caregiverObject = caregiver;
      });
    }

    setVisits(caregiversRefresh);

    if (push) {
      $timeout(function() {
        notificationsActive = false;
      }, 5000);

      if (!notificationsActive) {
        ////console.log($rootScope.stats);
        if ($rootScope.stats.waiting || $rootScope.stats.changes) {
          notificationsActive = true;
          //Notifications.desktop('New notification are waiting for you', '');
        }

      }
    }
  }

  $rootScope.$on('got_data', function(event) {
    //console.log('got all data');
    init();
    preSetVisits(true, 'caregivers');
  });

  $rootScope.$on('visit_changed', function(event) {
    preSetVisits(true);
  });

  $rootScope.$on('new_visit', function(event) {
    preSetVisits();
  });

  $rootScope.$on('caregiver_changed', function(event) {
    $rootScope.pendingCaregivers = DatabaseApi.getPendingCaregivers();
    preSetVisits(null, 'caregivers');
  });
  $rootScope.$on('new_caregiver', function(event) {
    preSetVisits(null, 'caregivers');
  });

  function getLastViewed(chat) {
    var last = undefined;
    chat.members.forEach(function(member) {
      if (member.user.type === 'AgencyMember') {
        ////console.log(member.user.agencyMemberId);
        var l = member.lastViewed;
        if (!last || last < l) last = l;
      }
    });
    ////console.log(last);
    return last;
  }

  function setVisits(caregiversRefresh) {

    $rootScope.notifications = [];
    const notifications = $rootScope.notifications;

    var pending = 0;
    var changes = 0;
    var scheduled = 0;
    var completed = 0;
    var confirmed = 0;
    var waiting = 0;
    var cancelled = 0;
    var unstaffed = 0;

    var chats = DatabaseApi.chats();
    var visits;
    const visitsResult = DatabaseApi.visits();
    if (visitsResult.broadcasts && visitsResult.unstaffed) {
      visits = visitsResult.broadcasts;
      unstaffed += visitsResult.unstaffed.length;
    } else {
      DatabaseApi.getVisits().then(db => {
        visits = db.visits.broadcasts;
        unstaffed += db.visits.unstaffed.length;
      });
    }
    var chatMap = {};
    chats.forEach(function(c) {

      if (!c.chatRoomType.visitId) return;
      //var last = getLastViewed(c);
      //var last = new Date(c.chat.agencyLastViewed).getTime();

      ////console.log(last);
      //if(!last || last < now){
      var visitId = c.chatRoomType.visitId.toString();
      if (!chatMap[visitId]) chatMap[visitId] = []
      chatMap[visitId].push(c.chatRoomType.caregiverId);
      //}

    });
    //console.log(chatMap);

    var notHR = !$rootScope.isHr();

    angular.forEach(visits, function(record) {

      record.status = VisitStatus.getVisitStatus(record);

      if (record.fullTimeOffered) {
        resolveCaregiverById(record.fullTimeOffered, function(c) {
          record.assignedCaregiverPending = c.firstName + ' ' + c.lastName + ' (pending)';
        });
      }

      if (record.awaitingCaregiverPatientContact) {
        resolveCaregiverById(record.awaitingCaregiverPatientContact, function(c) {
          record.awaitingCaregiverPatientContactName = c.firstName + ' ' + c.lastName + ' (pending)';
        });
      }


      if (notHR) {
        if (record.status === 'unstaffed') unstaffed++;
        else if (record.status === 'pending') pending++;
        else if (record.status === 'scheduled') scheduled++;
        else if (record.status === 'waiting') {
          $rootScope.notifications.push({
            type: 'waiting',
            data: record,
            time: new Date(record.updatedAt).getTime()
          });
          waiting++;
        }
      }

      /*
       if(record.newChatMessages) {
       $rootScope.notifications.push({type: 'message', data: record});
       $rootScope.totalNewChats += record.newChatMessages;
       }

       if(chatMap[record.id.toString()]){

       ////console.log('has chat');
       ////console.log(chatMap[record.id.toString()]);
       var c = chatMap[record.id.toString()];

       c.forEach(function(data){
       //console.log(data);
       var caregiver = DatabaseApi.getPro(data);
       if(!caregiver) return;
       var notification = {
       id: record.id,
       visitId: record.id,
       caregiverId: data,
       name: record.patientName,
       caregiverName: caregiver.displayName,
       type: 'message'
       }
       $rootScope.notifications.unshift(notification);
       });

       } */

    });

    var getNameFromVisitId = function(id) {
      var flag;
      visits.forEach(function(visit) {
        if (visit.id === id) flag = visit.patientName;
      });
      return flag;
    };

    chats.forEach(function(c) {

      if (!c.messages) return;
      var last = getLastViewed(c);
      //var last = new Date(c.chat.agencyLastViewed).getTime();
      /*
       //console.log('+++');
       //console.log(last);
       //console.log(new Date(c.messages[c.messages.length-1].createdAt).getTime());
       //console.log(last < new Date(c.messages[c.messages.length-1].createdAt).getTime());
       //console.log('+++');
       */
      if (c.messages.length && (!last || last < c.messages[c.messages.length - 1].createdAt)) {
        if (c.chatRoomType.type === 'AgencyMemberCaregiverChat') {
          resolveChatCaregiverName(c, function(caregiverName) {
          // Ignore callbacks from a notification rebuild superseded while loading.
          if ($rootScope.notifications !== notifications) return;
          c.messages.forEach(function(message) {

            if ($state.current.name === 'app.communication' && $rootScope.activeAgencyChat === c.id) return;
            if ((!last || message.createdAt > last) && message.user.type === 'Caregiver') {

              var notification = {
                id: c.id,
                caregiverId: c.chatRoomType.caregiverId,
                caregiverName: caregiverName,
                type: 'agencyMessage',
                time: new Date(message.createdAt).getTime()

              };
              $rootScope.notifications.unshift(notification);
            }
          });
          });

        } else if (c.chatRoomType.type === "CaregiverPatientChat") {
          resolveChatCaregiverName(c, function(caregiverName) {
          // Ignore callbacks from a notification rebuild superseded while loading.
          if ($rootScope.notifications !== notifications) return;
          for (const message of c.messages) {
            // There's no need to send a notification to the person who's already
            // in the conversation.
            if (
              $rootScope.activeChatPatient &&
              $rootScope.activeChatPatient.id === c.id
            ) {
              return;
            }

            const isNewMessage = !last || message.createdAt > last;
            const isMessageFromCaregiver = message.user.type === 'Caregiver';

            if (isNewMessage && isMessageFromCaregiver) {
              const notification = {
                id: c.id,
                caregiverId: c.chatRoomType.caregiverId,
                caregiverName: caregiverName,
                patientName: c.chatRoomType.patientName,
                patientId: c.chatRoomType.patientId,
                type: 'patientMessage',
                time: new Date(message.createdAt).getTime()

              };
              $rootScope.notifications.unshift(notification);
            }
          }
          });
        } else {
          if (notHR) {
            resolveChatCaregiverName(c, function(caregiverName) {
            // Ignore callbacks from a notification rebuild superseded while loading.
            if ($rootScope.notifications !== notifications) return;
            c.messages.forEach(function(message) {

              if ((!last || message.createdAt > last) && message.user.type === 'Caregiver') {


                var notification = {
                  id: c.id,
                  visitId: c.chatRoomType.visitId,
                  caregiverId: c.chatRoomType.caregiverId,
                  name: getNameFromVisitId(c.chatRoomType.visitId),
                  caregiverName: caregiverName,
                  type: 'message',
                  time: new Date(message.createdAt).getTime()
                };
                if (notification.name) {
                  $rootScope.notifications.unshift(notification);
                }
              }
            });
            });
          }
        }


      } else {
        ////console.log('+++not');
        ////console.log(c);

      }

    });

    $rootScope.stats.pending = pending;
    $rootScope.stats.scheduled = scheduled;
    $rootScope.stats.waiting = waiting;
    $rootScope.stats.changes = changes;
    $rootScope.stats.confirmed = confirmed;
    $rootScope.stats.completed = completed;
    $rootScope.stats.cancelled = cancelled;
    $rootScope.stats.unstaffed = unstaffed;

    if (caregiversRefresh) setCaregivers();
  }

  $rootScope.updateMentionsNotifications = function() {
    agencyMemberMentionsService.getInboxUnread().then((res) => {
      const mentions = res.data.unread || [];

      const mentionsNotifications = mentions.map(mention => {
        const { mentioningAgencyMemberName, noteId, mentionId } = mention;
        return {
          mentionId,
          noteId,
          mentioningAgencyMemberName,
          type: "noteMention",
          time: new Date(mention.createdAt).getTime()
        };
      });

      $rootScope.notifications = [
        ...$rootScope.notifications.filter(({ type }) => type !== "noteMention"),
        ...mentionsNotifications
      ];
    });
  }

  function setLegacyCaregivers() {

    const caregivers = DatabaseApi.caregivers();

    var statsCaregivers = {
      count: caregivers.length,
      active: 0,
      pending: 0,
      on_hold: 0,
      on_leave: 0,
      suspended: 0,
      terminated: 0,
      installed: 0,
      uninstalled: 0,
      activeInstalled: 0,
      pendingInstalled: 0,
      on_holdInstalled: 0,
      on_leaveInstalled: 0,
      suspendedInstalled: 0,
      terminatedInstalled: 0,
      activeUninstalled: 0,
      pendingUninstalled: 0,
      on_holdUninstalled: 0,
      on_leaveUninstalled: 0,
      suspendedUninstalled: 0,
      terminatedUninstalled: 0,
      ids: {
        active: [],
        pending: [],
        on_hold: [],
        on_leave: [],
        suspended: [],
        terminated: [],
        join_request: [],
        installed: [],
        unInstalled: [],
        notInstalled: [],
        activeInstalled: [],
        activeUnInstalled: [],
        activeNotInstalled: [],
        rejected: [],
        quit: [],
      }
    };

    var newCareGivers = 0;
    var hrDocs = 0;
    var oneDay = new Date().getTime() + 86400000;

    var haveFullTimeRns = false;

    for (var key in caregivers) {
      var record = caregivers[key];

      if (record.isFullTime) haveFullTimeRns = true;
      /*
      if (record.appInstalledDate && oneDay - new Date(record.appInstalledDate).getTime() > 0) {
        $rootScope.notifications.push({type: 'newCaregiver', data: record, time: new Date(record.appInstalledDate).getTime()});
        newCareGivers++;
      }
      */

      // status

      try {
        statsCaregivers[record.status.toLowerCase()]++;
        statsCaregivers.ids[record.status.toLowerCase()].push(record.id);
      } catch (e) {
        Sentry.captureException(new Error(`status does not exist: ${record.status.toLowerCase()}`));
      }


      if (record.appInstalled) {
        statsCaregivers[record.status.toLowerCase() + 'Installed']++;
        statsCaregivers.ids.installed.push(record.id);
        statsCaregivers.installed++;
        if (record.status.toLowerCase() === 'active') statsCaregivers.ids.activeInstalled.push(record.id);

      } else if (record.appInstalledDate) {
        statsCaregivers[record.status.toLowerCase() + 'Uninstalled']++;
        statsCaregivers.ids.unInstalled.push(record.id);
        statsCaregivers.uninstalled++;
        if (record.status.toLowerCase() === 'active') statsCaregivers.ids.activeUnInstalled.push(record.id);

      } else if (record.status.toLowerCase() === 'active') {
        statsCaregivers.ids.notInstalled.push(record.id);
        if (record.status.toLowerCase() === 'active') statsCaregivers.ids.activeNotInstalled.push(record.id);
      }

      //if (record.hrDocs < 100) hrDocs++;
    }

    $rootScope.haveFullTimeRns = haveFullTimeRns;

    $rootScope.stats.newCareGivers = newCareGivers;
    $rootScope.stats.hrPapers = hrDocs;


    $rootScope.stats.caregivers = statsCaregivers;
    $rootScope.stats.dataReady = true;
  }

  // Aggregate on the server only when the caregiver memory beta is enabled.
  function setCaregivers() {
    if (!useCaregiverMemoryImprovements) {
      setLegacyCaregivers();
      return;
    }

    DatabaseApi.get(
      'agencies/' + $rootScope.agencyId + '/agency_members/' +
      $rootScope.agencyMemberId + '/caregivers/stats'
    ).then(function (res) {
      if (!res || !res.data) return;

      const stats = { count: res.data.total };
      res.data.byStatus.forEach(function (row) {
        const key = row.status.toLowerCase();
        stats[key] = row.total;
        stats[key + 'Installed'] = row.installed;
        stats[key + 'Uninstalled'] = row.uninstalled;
      });
      stats.installed = res.data.byStatus.reduce((sum, r) => sum + r.installed, 0);
      stats.uninstalled = res.data.byStatus.reduce((sum, r) => sum + r.uninstalled, 0);

      $rootScope.stats.caregivers = stats;
      $rootScope.stats.dataReady = true;

      res.data.recentlyInstalled.forEach(function (caregiver) {
        $rootScope.notifications.push({
          type: 'newCaregiver',
          data: caregiver,
          time: new Date().getTime()
        });
      });
    });
  }

  $rootScope.getCalendarFirstDayOfWeek = () => {
    const value =
      typeof $rootScope.visitSettings.calendarStartDayOfTheWeek === "string"
        ? parseInt($rootScope.visitSettings.calendarStartDayOfTheWeek, 10)
        : $rootScope.visitSettings.calendarStartDayOfTheWeek;

    return {
      0: DayOfWeek.SUNDAY,
      1: DayOfWeek.MONDAY,
      2: DayOfWeek.TUESDAY,
      3: DayOfWeek.WEDNESDAY,
      4: DayOfWeek.THURSDAY,
      5: DayOfWeek.FRIDAY,
      6: DayOfWeek.SATURDAY,
    }[value];
  }


  function getTimeoutTime() {
    var time = $rootScope.visitSettings ? $rootScope.visitSettings.logOutTime : 10;
    return time ? time * 60000 : 60 * 60 * 24 * 1000;
  }

  var props = [{
      name: 'activeAgencyChat',
      type: 'b'
    },
    {
      name: 'activeChat',
      type: 'b'
    },
    {
      name: 'activeChatId',
      type: 'b'
    },
    {
      name: 'activeChatList',
      type: 'a'
    },
    {
      name: 'activeChatPatient',
      type: 'b'
    },
    {
      name: 'activeChatPatientVisit',
      type: 'b'
    },
    {
      name: 'activeIdx',
      type: 'b'
    },
    {
      name: 'activeModalId',
      type: 'b'
    },
    {
      name: 'agencyId',
      type: 'b'
    },
    {
      name: 'agencyId',
      type: 'b'
    },
    {
      name: 'agencyMemberId',
      type: 'b'
    },
    {
      name: 'caregiverChatId',
      type: 'b'
    },
    {
      name: 'visitDetails',
      type: 'o'
    },
    {
      name: 'notifications',
      type: 'a'
    },
    {
      name: 'totalNewChats',
      type: 'b'
    },
    {
      name: 'pendingCaregivers',
      type: 'a'
    },
    {
      name: 'pendingVisitEditRequests',
      type: 'a'
    },
    {
      name: 'commPageChatCounterCache',
      type: 'o'
    },
    {
      name: 'coordinatorRefferalCode',
      type: 'b'
    },
    //{name: 'token', type: 'b'},
    {
      name: 'userId',
      type: 'b'
    },
    {
      name: 'sweepCounter',
      type: 'b'
    },
    {
      name: 'sweepScore',
      type: 'b'
    },
    {
      name: 'internalChatCounter',
      type: 'b'
    },
    {
      name: 'stats',
      type: 'o'
    }
  ];

  $rootScope.idleLogout = function() {
    var t;
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.onkeydown = resetTimer;
    window.onwheel = resetTimer;
    window.ontouchstart = resetTimer;
    window.ontouchmove = resetTimer;
    window.onclick = resetTimer;
    window.onscroll = resetTimer;

    function logout() {
      $rootScope.user = {};
      $rootScope.refreshToken = undefined;
      props.forEach(function(p) {
        if (p.type === 'a') $rootScope[p.name] = [];
        if (p.type === 'b') $rootScope[p.name] = false;
        if (p.type === 'o') $rootScope[p.name] = {};
      });
      Storage.softClear();
      $window.location.reload();
      // $state.go('login');
    }

    function resetTimer() {
      clearTimeout(t);
      if (!$rootScope.user) return;
      t = setTimeout(logout, getTimeoutTime());
    }
  }
  $rootScope.idleLogout();


  /////////
  ///hubspot widget
  /////////
  // if (window.HubSpotConversations) {
  //   window.hsConversationsSettings = {
  //     loadImmediately: false, // Allows you to manually load the widget using .load()
  //   };
  //   window.HubSpotConversations.widget.load({ widgetOpen: false });
  // } else {
  //   window.hsConversationsOnReady = [
  //     () => {
  //       window.hsConversationsSettings = {
  //         loadImmediately: false, // Allows you to manually load the widget using .load()
  //       };
  //       window.HubSpotConversations.widget.load({ widgetOpen: false });
  //     },
  //   ];
  // }



  /////////
  ///chats
  /////////

  $rootScope.openAgencyChat = function(caregiverId) {
    if (!caregiverId) return;

    DatabaseApi.get('chats/agency_member_caregiver_chat_rooms/' + $rootScope.agencyMemberId + '/' + caregiverId).then(function(res) {
      var chat = res.data;
      //console.log(chat);

      //console.log('chat change');


      chat.agencyChat = true;

      if ((!$rootScope.stealthMode || chat.chatRoomType.agencyMemberId === $rootScope.agencyMemberId) && chat && chat.messages && chat.messages.length) {
        var last = chat.messages[chat.messages.length - 1].createdAt;
        DatabaseApi.put('chats/' + chat.id + '/viewed', {
          messageTime: last
        }).then(function(res) {});
      }

      $rootScope.activeAgencyChat = chat.id;
      $rootScope.openChat(chat, true);

    });
  };
  //  setTimeout(function(){
  //
  //  $rootScope.openAgencyChat(2);
  //  }, 2000);



  // OMER Asked to remove this on DEV-1570 in JIRA
  // $rootScope.openInternalChat = function () {

  //     var chat = DatabaseApi.getInternalChat();
  //     chat.isInternal = true;

  //     if (!chat.messages) return;

  //     $rootScope.internalChatCounter = 0;

  //     $rootScope.activeChatId = chat.id;

  //     $rootScope.activeChat = chat;

  //     if (chat.messages.length) {
  //         var last = $rootScope.activeChat.messages[$rootScope.activeChat.messages.length - 1].createdAt;

  //         DatabaseApi.put('chats/' + chat.id + '/viewed', { messageTime: last }).then(function (res) {
  //             if (!$rootScope.activeChat.members) $rootScope.activeChat.members = [];
  //             $rootScope.activeChat.members.forEach(function (member, i) {
  //                 if (member.user.agencyMemberId === $rootScope.agencyMemberId) {
  //                     $rootScope.activeChat.members[i].lastViewed = last;
  //                 }
  //             });

  //             DatabaseApi.setInternalChat($rootScope.activeChat);
  //         });
  //     } else {
  //         DatabaseApi.setInternalChat($rootScope.activeChat);
  //     }

  //     //console.log($rootScope.activeChat);
  //     $rootScope.chatForm = { text: '' };

  //     $rootScope.isChatOpen = false;
  //     $timeout(function () {
  //         $rootScope.isChatOpen = true;
  //     }, 1);

  // };


  $rootScope.openChat = function(chatRow, gotMessages) {


    var chatRowNew = angular.copy(chatRow);

    if (!chatRowNew.agencyChat) {
      $rootScope.activeAgencyChat = false;
    }

    $rootScope.chatForm = {
      text: ''
    };
    $rootScope.activeChat = null;

    if (gotMessages) {
      startRoom(chatRowNew);

    } else if (chatRowNew.id && chatRowNew.id !== -1 && !chatRowNew.fromList) {

      DatabaseApi.getMessagesByIds(chatRowNew.id).then(
        function(res) {

          startRoom(chatRow, res);


        },
        function(err) {
          //console.log(err);
        }
      );


    } else {
      var flag = false;
      if (!chatRowNew.chatRoomType && chatRowNew.caregiverId && chatRowNew.patientId) {
        flag = true;
        chatRowNew.chatRoomType = {
          caregiverId: chatRowNew.caregiverId,
          patientId: chatRowNew.patientId,
        }
      } else if (chatRowNew.fromList) {
        flag = true;
      }

      // Chat click via visit
      const currentVisit = $rootScope.activeChatPatientVisit;
      let url;
      if (currentVisit) {
        url = wildcard(
          "chats/caregiver/:caregiverId/patient/:patientId/visit/:visitId",
          chatRowNew.chatRoomType.caregiverId,
          chatRowNew.chatRoomType.patientId,
          currentVisit.id
        );
      } else {
        url = wildcard(
          "chats/caregiver/:caregiverId/patient/:patientId",
          chatRowNew.chatRoomType.caregiverId,
          chatRowNew.chatRoomType.patientId
        );
      }

      DatabaseApi.get(url).then(function(res) {

        if (flag) chatRowNew = res.data;

        chatRowNew.id = res.data.id;

        //$rootScope.openChat(chatRowNew);
        startRoom(chatRowNew);

      }, function(err) {

      });
    }
  };

  function startRoom(chatRow, res) {
    $rootScope.activeChatId = chatRow.id;

    if (chatRow.agencyChat) {
      $rootScope.activeChatPatient = undefined;
    } else {
      var patientId = chatRow.chatRoomType ? chatRow.chatRoomType.patientId : chatRow.patientId;
      // Resolved by id; the chat header fills in when it lands.
      $rootScope.activeChatPatient = undefined;
      patientLookupService.byId(patientId).then(function (patient) {
        $rootScope.activeChatPatient = patient === null ? undefined : patient;
      });
    }

    $rootScope.activeChat = res || chatRow;

    try {
      if (res && chatRow) chatRow = Object.assign(chatRow, res);

    } catch (e) {
      toaster.pop('error', 'Browser Not Supported', 'Please use chrome browser');

    }

    try {
      $rootScope.activeChat.caregiver = chatRow.chatRoomType ? chatRow.chatRoomType.caregiverId : chatRow.caregiverId;

      $rootScope.activeChat.caregiverName = chatRow.displayName;
      resolveCaregiverById($rootScope.activeChat.caregiver, function(caregiver) {
        $rootScope.activeChat.caregiverObject = caregiver;
        if (!$rootScope.activeChat.caregiverName) {
          $rootScope.activeChat.caregiverName = caregiver.displayName;
        }
      });
    } catch (e) {
      console.log(e);
      toaster.pop('warning', 'Something went wrong', 'Please reload/refresh page');
    }
    var viewed;
    if ($rootScope.activeChat.members) {
      $rootScope.activeChat.members.forEach(function(member) {

        if (member.user.type === "Caregiver") {
          viewed = member.lastViewed;
        }

      });
    }
    $rootScope.activeChat.viewed = viewed;

    if ((!$rootScope.stealthMode || $rootScope.activeChat.chatRoomType.agencyMemberId === $rootScope.agencyMemberId) && $rootScope.activeChat.messages.length && chatRow.id) {
      var last = $rootScope.activeChat.messages[$rootScope.activeChat.messages.length - 1].createdAt;
      DatabaseApi.put('chats/' + $rootScope.activeChatId + '/viewed', {
        messageTime: last
      }).then(function(res) {
        if (!$rootScope.activeChat.members) $rootScope.activeChat.members = [];
        $rootScope.activeChat.members.forEach(function(member, i) {
          if (member.user.type === 'AgencyMember') {
            $rootScope.activeChat.members[i].lastViewed = last;
          }
        });
        //console.log($rootScope.activeChat);
        if (!chatRow.agencyChat) DatabaseApi.setChat($rootScope.activeChat);
        //setVisits();
        $rootScope.$broadcast('visit_changed');
      });
    }
    //console.log($rootScope.activeChat);
    //console.log('start room');
    $rootScope.chatForm.text = '';

    $rootScope.isChatOpen = false;
    $timeout(function() {
      $rootScope.isChatOpen = true;
    }, 1);
  }

  $rootScope.closeChat = function() {
    $timeout(function() {
      $rootScope.isChatOpen = false;
    }, 1);
    $rootScope.activeChatId = false;
    $rootScope.activeChatPatient = false;
    $rootScope.activeChatPatientVisit = false;
    $rootScope.activeChat = null;
    $rootScope.activeAgencyChat = false;
  };

  $rootScope.assignCaregiverToPatientChat = function(visit, patient, caregiver, cb) {
    if (caregiver.status !== "ACTIVE") {
      toaster.pop("warning", "Unable to perform action", "Caregiver is not active");
    }

    if (!visit) {
      $uibModal.open({
        templateUrl: "admin/views/pick-visit-modal.html",
        size: "lg",
        controller: "pickVisitModalCtrl",
        resolve: {
          caregiver: () => caregiver,
          patientId: () => patient !== undefined ? patient.id : undefined
        }
      })
      return;
    }

    if (visit.status === "scheduled") {
      SweetAlert.swal({
        title: "The case has already been assigned!",
        type: "error",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        closeOnConfirm: true
      });
      return;
    }

    if (visit.flexibleVisitParams || visit.rnVisitParams) {
      toaster.pop(
        "warning",
        "Cannot assign - action required",
        "Please ask the caregiver to selected the preferred days and/or time"
      );
      return;
    }

    let caregiverId;

    if (caregiver) {
      caregiverId = caregiver.caregiver ? caregiver.caregiver : caregiver.id;
    } else {
      return toaster.pop("error", "Something went wrong");
    }

    if (visit.isSingleVisit) {
      const url = wildcard(
        "agencies/:agencyId/agency_members/:agencyMemberId/visits/:visitId/assigned_to",
        $rootScope.agencyId,
        $rootScope.agencyMemberId,
        visit.id
      );

      const body = {
        caregiverId: caregiverId,
        partialAssignDetails: null,
        flexibleVisitRequestParams: null
      }

      DatabaseApi.put(url, body)
        .then((res) => {
          if (res.data.assignedWithOvertime) {
              toaster.pop({
                  type: 'warning',
                  title: 'Warning',
                  body: `Caregiver was assigned with increased caregiver overtime`
              });
          } else {
            toaster.pop("success", "Success", "Caregiver has assigned to visit");
          }

          Analytics.event("visit-chat-assigned", {
            visitId: visit.id,
            status: "scheduled",
            newCaregiver: caregiverId,
            accepted: visit.acceptedBy.length
          });

          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          if (err.data && err.data.error === "Not permitted to increase caregiver overtime") {
            toaster.pop('error', 'Error', err.data.error);
          } else {
            toaster.pop("error", "Error", "Failed to assign visit.");
          }
          console.error(err);
        })
    } else {
      const modalInstance = $uibModal.open({
        templateUrl: 'admin/views/assign-modal.html',
        size: 'md',
        controller: 'assignModalCtrl',
        windowClass: 'top-top',
        resolve: {
          visit: () => visit,
          caregiver: () => caregiver
        }
      });

      modalInstance.result.then(() => {
        if (cb) {
          cb();
        }
      });
    }
  }

  $rootScope.assignCaregiverToVisitChat = function(visit, caregiver, cb) {
    //console.log(visit);
    //console.log(caregiver);
    let patientId;
    if (caregiver.chat) {
      patientId = caregiver.chat.chatRoomType.patientId;
    }

    if (caregiver.status !== "ACTIVE") {
      toaster.pop("warning", "Unable to preform action", "Caregiver is not active");
      return;
    }
    if (!visit) {
      //console.log('agencyChat');
      var modalInstance = $uibModal.open({
        templateUrl: 'admin/views/pick-visit-modal.html',
        size: 'lg',
        controller: 'pickVisitModalCtrl',
        resolve: {
          caregiver: function() {
            return caregiver;
          },
          patientId: function() {
            return patientId;
          }
        }

      });
      modalInstance.result.then(function(res) {
        console.log('modal out');
        //console.log(res);
      }, function() {
        console.log('modal close');
      });

    } else if (visit.status === 'scheduled') {

      SweetAlert.swal({
        title: "The case has already been assigned!",
        text: "",
        type: "error",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        closeOnConfirm: true
      });

    } else if (visit.flexibleVisitParams || visit.rnVisitParams) {

      toaster.pop('warning', "Cannot assign - action required", 'Please ask caregiver to select preferred days and/or hours');

    } else {

      if (caregiver) {
        var caregiverId = caregiver.caregiver ? caregiver.caregiver : caregiver.id;
      } else {
        return toaster.pop('error', "Something went wrong");
      }

      if (visit.isSingleVisit) {


        //console.log(caregiver);
        var url = "agencies/" + $rootScope.agencyId + "/agency_members/" + $rootScope.agencyMemberId + "/visits/" + visit.id + "/assigned_to";
        DatabaseApi.put(url, {
          caregiverId: caregiverId,
          partialAssignDetails: null,
          flexibleVisitRequestParams: null
        }).then(function(res) {
          if (res.data.assignedWithOvertime) {
              toaster.pop({
                  type: 'warning',
                  title: 'Warning',
                  body: `Caregiver was assigned with increased caregiver overtime`
              });
          } else {
            toaster.pop("success", "Success", "Caregiver has assigned to visit");
          }

          Analytics.event('visit-chat-assigned', {
            visitId: visit.id,
            status: 'scheduled',
            newCaregiver: caregiverId,
            accepted: visit.acceptedBy.length
          });


          //$rootScope.sweepScore.points += 100;

          if (cb) cb();

        }, function(err) {

          var errText = '';
          if (err.data) errText = err.data.error ? err.data.error : '';

          if (err.status === 409) toaster.pop('error', "Assigning Conflict", errText);
          else {

            toaster.pop('error', "Something went wrong", errText);
          }
        });

      } else {

        var modalInstance = $uibModal.open({
          templateUrl: 'admin/views/assign-modal.html',
          size: 'md',
          controller: 'assignModalCtrl',
          windowClass: 'top-top',
          resolve: {
            visit: function() {
              return visit;
            },
            caregiver: function() {
              return caregiver;
            }
          }

        });
        modalInstance.result.then(function(res) {
          //console.log('modal click');
          //console.log(res);
          if (cb) cb();

        }, function() {
          //console.log('modal close');
        });

      }



    }

  };

  $rootScope.closeSweepStakesFlag = {
    state: false
  }
  $rootScope.closeSweepStakes = function(forever) {
    $rootScope.showSweepStakes = false;
    if ($rootScope.closeSweepStakesFlag.state) Storage.set('hide-sweep-vegas', 'true');
    //console.log(forever);
  };

  $rootScope.goToSweepRules = function() {
    $window.open('https://s3-us-west-2.amazonaws.com/medflytfiles/Sweepstakes+Rules+and+Terms.pdf');
  };
  $rootScope.goToInviteCaregiver = function() {
    $state.go('app.addCaregiver');
  };

  $rootScope.newChatMessage = function(caregiverId, caregiverId2, visitId, message, chatId) {
    var caregiver = caregiverId ? caregiverId : caregiverId2;
    //console.log($rootScope.activeChat);
    DatabaseApi.postMessage(caregiver, visitId, message, chatId);
    //console.log('new chat message');
    $rootScope.chatForm.text = '';
  };

  /*

  $rootScope.$on('visit_chat_updated', function (event, data) {
    ////console.log(data.caregiverId);
    // //console.log(data.visitId);
    return;


  });
  */

  $rootScope.$on('sweep_score_updated', function(event) {
    DatabaseApi.connect('onlyScore');
  });

  // Nothing to refresh: the patient dictionary this reloaded is gone, and the
  // pages that show a patient resolve it by id when they render.


  $rootScope.$on('chat_room_updated', function(event, data) {
    //return;

    DatabaseApi.getMessagesByIds(data.id).then(function(res) {
      //$rootScope.$broadcast('visit_changed');
      res.data = res;
      //var res = {data: res};
      //console.log(res.data);




      if (res.data.chatRoomType.type === 'InternalAgencyChat') {
        var oldChat = DatabaseApi.getInternalChat();
        var agencyMembersMap = DatabaseApi.getAgencyMembers();
        var isNewMessage;
        if (oldChat && oldChat.messages) {
          isNewMessage = res.data.messages.length > oldChat.messages.length;
        } else {
          isNewMessage = true;
        }
        res.data.isInternal = true;
        if ($rootScope.activeChat && $rootScope.activeChatId === res.data.id) {

          res.data.messages.forEach(function(message) {
            message.name = agencyMembersMap[message.user.agencyMemberId.toString()];
          });

          $rootScope.activeChat.messages = res.data.messages;
          $rootScope.activeChat.members = res.data.members;
          //$rootScope.activeChat.viewed = res.data.viewed;
          $rootScope.internalChatCounter = 0;

          var myLastView;
          $rootScope.activeChat.members.forEach(function(member, i) {
            if (member.user.agencyMemberId === $rootScope.agencyMemberId) myLastView = member.lastViewed;
          });

          if (myLastView && $rootScope.activeChat.messages.length &&
            $rootScope.activeChat.messages[$rootScope.activeChat.messages.length - 1].createdAt > myLastView) {
            var last = $rootScope.activeChat.messages[$rootScope.activeChat.messages.length - 1].createdAt;
            DatabaseApi.put('chats/' + res.data.id + '/viewed', {
              messageTime: last
            }).then(function(res) {

              $rootScope.activeChat.members.forEach(function(member, i) {
                if (member.user.agencyMemberId === $rootScope.agencyMemberId) {
                  $rootScope.activeChat.members[i].lastViewed = last;
                }
              });

              DatabaseApi.setInternalChat($rootScope.activeChat);

            });
          }
        } else {
          if (res.data.messages.length && isNewMessage &&
            res.data.messages[res.data.messages.length - 1].user.agencyMemberId !== $rootScope.agencyMemberId) {
            //console.log('++ conf');
            $rootScope.internalChatCounter++;
            try {
              bell.play().then(function(value) {
                bell.play();
              });
              Notifications.desktop("New Internal Chat", 'There is a new chat message');
            } catch (e) {

            }
          }
          DatabaseApi.setInternalChat(res.data);
        }

        //console.log(res.data);

      } else if (res.data.chatRoomType.type === 'AgencyMemberCaregiverChat') {

        var viewed = undefined;
        res.data.members.forEach(function(member) {
          if (member.user.type === 'Caregiver') {
            viewed = member.lastViewed;
          }
        });
        res.data.viewed = viewed;

        //console.log('AgencyMemberCaregiverChat');
        if ($rootScope.activeChat && $rootScope.activeAgencyChat === res.data.id && !$rootScope.activeChat.isInternal) {
          //console.log('AgencyMemberCaregiverChat active');
          $rootScope.activeChat.agencyLastViewed = res.agencyLastViewed;
          $rootScope.activeChat.caregiverLastViewed = res.caregiverLastViewed;
          $rootScope.activeChat.messages = res.messages;
          $rootScope.activeChat.members = res.data.members;
          $rootScope.activeChat.viewed = res.data.viewed;
        } else if (res.data.messages && res.data.messages[res.data.messages.length - 1] && res.data.messages[res.data.messages.length - 1].user.type !== "AgencyMember") {
          resolveCaregiverById(res.data.chatRoomType.caregiverId, function(proObject) {
          if (!data.onlyView) {
            var lastViewByAgencyMember = getLastViewed(res.data);
            if (res.data.messages.length && (!lastViewByAgencyMember || lastViewByAgencyMember < res.data.messages[res.data.messages.length - 1].createdAt)) {
              var notification = {
                id: res.data.id,
                caregiverId: res.data.chatRoomType.caregiverId,
                caregiverName: caregiverDisplayName(proObject),
                type: 'agencyMessage'
              }
              $rootScope.notifications.unshift(notification);
              Notifications.desktop("New Agency Chat", 'There is a new chat message from ' + notification.caregiverName);
              try {
                bell.play().then(function(value) {
                  bell.play();
                });
              } catch (e) {

              }
            }
          }
          });
        }

        ////console.log(res.data);
        //setVisits();

        if (res.data.members) {
          var lastViewed;
          res.data.members.forEach(function(member) {
            if (member.user.type === 'AgencyMember') {
              if (member.lastViewed > lastViewed) lastViewed = member.lastViewed;
              else if (!lastViewed) lastViewed = member.lastViewed;
            }
          });
        }

        var notViewedCounter = 0;
        if (res.data.messages) {

          if (lastViewed) {
            var messagesLength = res.data.messages.length - 1;
            for (var i = messagesLength; i >= 0; i--) {
              if (!res.data.messages[i].broadcast && res.data.messages[i].createdAt > lastViewed) notViewedCounter++;
              else break;
            }
          }
          res.data.notViewedCounter = notViewedCounter || 0;
          if (notViewedCounter) $rootScope.commPageChatCounterCache[res.data.id] = true;
          else delete $rootScope.commPageChatCounterCache[res.data.id];
        }

        $rootScope.$broadcast('chat_room_updated_com', {
          data: data,
          res: res
        });

      } else if (res.data.chatRoomType.type === 'CaregiverPatientChat') {
        var viewed;
        res.data.members.forEach(function(member) {
          if (member.user.type === "Caregiver") {
            viewed = member.lastViewed;
          }
        });
        res.data.viewed = viewed;

        if (
          !$rootScope.activeChat ||
          ($rootScope.activeChatPatient && $rootScope.activeChatPatient.id !== data.chatRoomType.patientId) ||
          $rootScope.activeChat.chatRoomType.caregiverId !== data.caregiverId) {

          const patientId = res.data.chatRoomType ? res.data.chatRoomType.patientId : data.patientId;
          var caregiverId = res.data.chatRoomType ? res.data.chatRoomType.caregiverId : data.caregiverId;
          const message = res.data.messages[res.data.messages.length - 1];
          $q.all({
            patient: patientLookupService.byId(patientId),
            caregiver: caregiverLookupService.byId(caregiverId)
          }).then(function ({ patient, caregiver }) {
          if (!data.onlyView && caregiver && patient && message && message.user.type === 'Caregiver') {
            var notification = {
              id: res.data.id,
              patientId: patientId,
              caregiverId: caregiverId,
              name: patient.displayName,
              caregiverName: caregiverDisplayName(caregiver),
              type: 'message'
            }
            $rootScope.notifications.unshift(notification);
            Notifications.desktop("New Patient Chat", 'There is a new chat message from ' + notification.caregiverName + ' about ' + notification.name);
            try {
              bell.play().then(function(value) {
                bell.play();
              });
            } catch (e) {

            }
          }
          });
        }
        if (
          $rootScope.activeChat &&
          $rootScope.activeChatPatient &&
          $rootScope.activeChat.chatRoomType.caregiverId === res.data.chatRoomType.caregiverId
        ) {
          $rootScope.activeChat.agencyLastViewed = res.agencyLastViewed;
          $rootScope.activeChat.caregiverLastViewed = res.caregiverLastViewed;
          $rootScope.activeChat.messages = res.messages;
          $rootScope.activeChat.members = res.data.members;
          $rootScope.activeChat.viewed = res.data.viewed;
        }
        //console.log('changed');
        //console.log($rootScope.activeChat);
        $rootScope.$broadcast('visit_changed');


      }


    }, function(err) {
      //console.log(err);
    });
    /*
     DatabaseApi.get('chats/' + data.chatRoomId).then(function(res){


     //console.log(res.data);
     //console.log(data);




     });*/
  });

  $rootScope.getCaregiverPageURL = function(id) {
    if (isMissingEntityModalId(id)) return;
    return window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?caregiver=${id}`;
  }

  $rootScope.openNoteMention = function(noteId, mentionId) {
    $state.go(
      "app.notes.mentionsInbox",
      { noteId, mentionId },
      { reload: true }
    );
  };

  $rootScope.openCaregiverModal = function(id, caregiverData, forceModal, applicationLandingCertification, { redirect, onClose } = { redirect: true }) {
    if (isMissingEntityModalId(id)) return;

    let pathStateWithQuery = $rootScope.getCaregiverPageURL(id);

    if (redirect) {
      window.history.pushState({
        path: pathStateWithQuery
      }, "", pathStateWithQuery);
    }
    
    // Since the pushState() above doesn't trigger $stateChangeStart nor popState events, we open the modal "manually"
    $rootScope.handleOpenCaregiverModal(id, caregiverData, forceModal, applicationLandingCertification, onClose);
  };

  // Records people quote by id: a claim number off an email, a check number off a remittance, a
  // visit id from a report. Each one is a navigate - it opens the record, it never changes it.
  // permissionKey mirrors the sidebar entry for the same area, so a user who cannot reach the page
  // is never told the capability exists.
  registerAiCapability(
    {
      id: "calls.open",
      title: "Open the phone clock-in calls worklist",
      effect: "navigate",
      description:
        "Opens the EVV calls worklist - the clock in and out calls that came in by phone (IVR), including the ones that could not be matched to a visit and need linking by hand.",
      location: "the EVV area",
      permissionKey: "view_evv_calls",
      // Being on this page is what makes the link-call dialog reachable.
      opens: ["evv-calls"],
      params: [
        {
          name: "view",
          type: "enum",
          required: false,
          description: "Which list to show. Defaults to the calls needing attention.",
          options: [
            { value: "calls", label: "Unlinked calls" },
            { value: "rejected", label: "Rejected calls" }
          ]
        }
      ],
      examples: ["show me the phone clock-in calls", "open the unlinked IVR calls", "rejected calls"]
    },
    (args) => {
      const isRejected = String(args.view ?? "calls") === "rejected";

      $state.go(isRejected ? "app.evv.calls.rejected" : "app.evv.calls.maintenance");

      return isRejected ? "Opened rejected calls" : "Opened the calls worklist";
    }
  );

  registerAiCapability(
    {
      id: "export.open",
      title: "Open an export batch",
      effect: "navigate",
      description:
        "Opens an export batch with the claims and visits in it, its errors and the file that was produced.",
      location: "the exports area of billing",
      permissionKey: "view_billing_section_exports",
      params: [
        { name: "export", type: "number", required: true, description: "The export batch id." }
      ],
      examples: ["open export batch 4471"]
    },
    (args) => {
      $state.go("app.billing.export", { id: args.export });

      return "Opened export batch " + args.export;
    }
  );

  registerAiCapability(
    {
      id: "workflowTask.open",
      title: "Open a workflow task",
      effect: "navigate",
      description:
        "Opens a single workflow task, showing its steps, entities and who it is assigned to.",
      location: "the workflows area",
      permissionKey: "view_workflow_task|view_workflows",
      params: [
        { name: "task", type: "number", required: true, description: "The workflow task id." }
      ],
      examples: ["open workflow task 71"]
    },
    (args) => {
      $state.go("app.workflow_tasks.task", { id: args.task });

      return "Opened workflow task " + args.task;
    }
  );

  registerAiCapability(
    {
      id: "commCenterTicket.open",
      title: "Open a communication ticket",
      effect: "navigate",
      description:
        "Opens a comm center ticket - the conversation thread for a caregiver or patient, including its calls, emails and IVR events.",
      location: "the comm center",
      permissionKey: "view_communication_center|view_communication_section",
      params: [
        { name: "ticket", type: "number", required: true, description: "The ticket id." }
      ],
      examples: ["open ticket 2204", "show me conversation 2204"]
    },
    (args) => {
      $state.go("app.commcenter_ticket", { ticketId: args.ticket });

      return "Opened ticket " + args.ticket;
    }
  );

  registerAiCapability(
    {
      id: "patientIssue.open",
      title: "Open a patient issue",
      effect: "navigate",
      description:
        "Opens a single patient issue with its type, severity, description and resolution.",
      location: "the patient issues page",
      permissionKey: "view_patient_issues",
      params: [
        { name: "issue", type: "number", required: true, description: "The patient issue id." }
      ],
      examples: ["open patient issue 88"]
    },
    (args) => {
      $state.go("app.patients.patientIssues.issue", { id: args.issue });

      return "Opened patient issue " + args.issue;
    }
  );

  registerAiCapability(
    {
      id: "note.create",
      title: "Write a note",
      effect: "prefill",
      description:
        "Opens the note composer, either for a single note or for creating notes in bulk. The user chooses the subject and writes the note; nothing is saved until they do.",
      location: "a dialog over the current page",
      permissionKey: "view_notes_section",
      params: [
        {
          name: "bulk",
          type: "boolean",
          required: false,
          description: "True to open the bulk note composer instead of a single note."
        }
      ],
      examples: ["add a note", "create bulk notes"]
    },
    (args) => {
      $rootScope.openNoteCreateModal(args.bulk === true);

      return args.bulk === true ? "Opened the bulk note composer" : "Opened a new note";
    }
  );

  registerAiCapability(
    {
      id: "visit.open",
      title: "Open a visit",
      effect: "navigate",
      description:
        "Opens the page for a single visit, showing its schedule, assigned caregiver, clock times and billing state.",
      location: "the visit page, reachable from any page",
      permissionKey: "view_visits_section_instances",
      params: [
        {
          name: "visit",
          type: "number",
          required: true,
          description: "The visit id."
        }
      ],
      examples: ["open visit 44821"]
    },
    (args) => {
      $state.go("app.single-visit", { id: args.visit });

      return "Opened visit " + args.visit;
    }
  );

  registerAiCapability(
    {
      id: "visitBroadcast.open",
      title: "Open a visit broadcast",
      effect: "navigate",
      description:
        "Opens the broadcast for a visit - the offer sent out to caregivers - showing who it went to and how they responded.",
      location: "a modal, reachable from any page",
      permissionKey: "view_visits_section_list",
      params: [
        {
          name: "broadcast",
          type: "number",
          required: true,
          description: "The visit broadcast id."
        }
      ],
      examples: ["open broadcast 5512", "show me visit broadcast 5512"]
    },
    (args) => {
      $rootScope.handleOpenVisitBroadcastModal(args.broadcast);

      return "Opened broadcast " + args.broadcast;
    }
  );

  registerAiCapability(
    {
      id: "advancedReport.open",
      title: "Open the report builder",
      effect: "navigate",
      description:
        "Opens the advanced report builder - the blank report tool, where a report is put together from the agency's own tables and columns. Nothing is built by opening it.",
      location: "Reports > Advanced",
      permissionKey: "view_reports_section_advanced",
      // Being in the tool is what makes building one possible.
      opens: ["advanced-report-tool"],
      params: [],
      examples: ["open the report builder", "new advanced report"]
    },
    () => {
      $state.go("app.reports.reportTool");

      return "Opened the report builder";
    }
  );

  registerAiCapability(
    {
      id: "invoice.open",
      title: "Open a payment claim",
      effect: "navigate",
      description:
        "Opens a payment claim (invoice) with its visits, amounts and export history. The claim is identified by the display id people quote, not an internal one.",
      location: "a modal, reachable from any page",
      permissionKey: "view_billing_section_invoices",
      params: [
        {
          name: "invoice",
          type: "invoiceRef",
          required: true,
          description: "The claim number as it appears in the app, or an id."
        }
      ],
      examples: ["open claim 900123", "pull up invoice 900123"]
    },
    (args, context) => {
      $rootScope.openInvoiceModal({ invoiceId: args.invoice });

      return "Opened " + (context.labels.invoice ?? "claim " + args.invoice);
    }
  );

  registerAiCapability(
    {
      id: "check.open",
      title: "Open a check",
      effect: "navigate",
      description:
        "Opens a received check with the claims it was applied to and the amounts still outstanding.",
      location: "the checks area of billing",
      permissionKey: "view_billing_section_checks",
      params: [
        {
          name: "check",
          type: "number",
          required: true,
          description: "The check id."
        }
      ],
      examples: ["open check 3391"]
    },
    (args) => {
      $state.go("app.billing.check", { id: args.check });

      return "Opened check " + args.check;
    }
  );

  registerAiCapability(
    {
      id: "payrollBatch.open",
      title: "Open a payroll batch",
      effect: "navigate",
      description:
        "Opens a payroll batch with the caregivers and hours in it, ready to review before it is approved.",
      location: "the payroll area",
      permissionKey: "view_payroll_section_batches",
      params: [
        {
          name: "batch",
          type: "number",
          required: true,
          description: "The payroll batch id."
        }
      ],
      examples: ["open payroll batch 88"]
    },
    (args) => {
      $state.go("app.payroll.batch", { id: args.batch });

      return "Opened payroll batch " + args.batch;
    }
  );

  // Same, for the caregiver side.
  registerAiCapability(
    {
      id: "caregiver.openModal",
      title: "Open a caregiver's profile",
      effect: "navigate",
      description:
        "Opens the full caregiver profile as a slide-in modal over the current page, with their visits, compliance, certifications and documents.",
      location: "a slide-in modal, reachable from any page",
      opens: ["caregiver-profile"],
      params: [
        {
          name: "caregiver",
          type: "caregiverRef",
          required: true,
          description: "Which caregiver: their id as shown in the app, or their name."
        }
      ],
      examples: ["open caregiver 41", "pull up Maria Lopez"]
    },
    (args, context) => {
      $rootScope.openCaregiverModal(args.caregiver);

      return "Opened " + (context.labels.caregiver ?? "the caregiver");
    }
  );

  $rootScope.openCaregiverNewTab = function(id) {
    if (isMissingEntityModalId(id)) return;

    let pathStateWithQuery = $rootScope.getCaregiverPageURL(id);

    window.open(pathStateWithQuery, "_blank");
  }

  function getCaregiverModalRoute(id) {
    const rawId = String(id);

    const numericId = Number(rawId);

    // Explicit "legacy window for this caregiver" override — see the patient
    // equivalent; it ignores the profile window setting on purpose.
    if (Number.isFinite(numericId) && numericId < 0) {
      return {
        id: Math.abs(numericId),
        key: rawId,
        templateUrl: "admin/views/professional-modal.html",
        useReact: false,
      };
    }

    if (!isBetaProfileWindowEnabled()) {
      return {
        id: Number.isFinite(numericId) ? numericId : id,
        key: rawId,
        templateUrl: "admin/views/professional-modal.html",
        useReact: false,
      };
    }

    return {
      id: Number.isFinite(numericId) ? numericId : id,
      key: rawId,
      templateUrl: "admin/views/react-caregiver-modal.html",
      useReact: true,
    };
  }

  $rootScope.handleOpenCaregiverModal = function(id, caregiverData, forceModal, applicationLandingCertification, onClose) {
    const caregiverModalRoute = getCaregiverModalRoute(id);

    if (
      $rootScope.currentOpenedPatientIdModal !== undefined
    ) {
      $rootScope.closePatientModal(true);
    }

    if (
      $rootScope.currentOpenedCaregiverIdModal &&
      $rootScope.currentOpenedCaregiverIdModal !== caregiverModalRoute.key
    ) {
      $rootScope.closeCaregiverModal();
    }

    if ($rootScope.currentOpenedCaregiverIdModal === caregiverModalRoute.key) {
      return;
    }

    $rootScope.currentOpenedCaregiverIdModal = caregiverModalRoute.key;
    $rootScope.isEntityModalContentBlocked = caregiverModalRoute.useReact;
    $rootScope.caregiverModalInstance = $uibModal.open({
      templateUrl: caregiverModalRoute.templateUrl,
      size: 'lg',
      backdrop: true,
      controller: caregiverModalRoute.useReact
        ? ["$scope", "id", function($scope, id) {
          $scope.reactCaregiverModal = {
            caregiverId: id
          };
        }]
        : 'professionalCtrl',
      windowClass: "modal modal-slide-in-right caregiver-modal",
      resolve: {
        id: function() {
          return caregiverModalRoute.id;
        },
        pro: function() {
          return caregiverData;
        },
        forceModal: function() {
          return forceModal;
        },
        offices: function($rootScope, officesService) {
          if (!officesService.offices) {
            return officesService.getOffices();
          } else {
            return officesService.offices;
          }
        },
        applicationLandingCertification: function() {
          return applicationLandingCertification;
        }
      }

    });
    $rootScope.caregiverModalInstance.closed.then(function(res) {
      $rootScope.closeCaregiverModal();
    });
    $rootScope.caregiverModalInstance.result.finally(() => {
      $rootScope.isEntityModalContentBlocked = false;
      // First modal close: reveal the main ui-view (and keep it from now on).
      $rootScope.suppressMainView = false;
      // Safety net: if the modal never reported ready, the badges would otherwise
      // stay deferred forever. Idempotent, so harmless when ready already fired.
      $rootScope.flushNavbarBadges();
      $rootScope.currentOpenedCaregiverIdModal = undefined;
      onClose?.();
      $state.go(
        $state.current.name, {
          caregiver: null
        }, {
          reload: false
        }
      );
    });
  };

  $rootScope.getInvoicePageURL = function(id) {
    if (!id) return;
    return window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?invoice=${id}`;
  }

  $rootScope.getCheckPageURL = function(id) {
    return window.location.protocol +
      "//" +
      window.location.host +
      '/app/billing/checks/' +
      id;
  }

  $rootScope.openInvoiceModal = function({ invoiceId, forceModal }) {
    let pathStateWithQuery = $rootScope.getInvoicePageURL(invoiceId);
    window.history.pushState({ path: pathStateWithQuery }, "", pathStateWithQuery);
    $rootScope.handleOpenInvoiceModal({ invoiceId, forceModal });
  };

  $rootScope.openInvoiceNewTab = function(id) {
    if (!id) return;
    let pathStateWithQuery = $rootScope.getInvoicePageURL(id);
    window.open(pathStateWithQuery, "_blank");
  }

  $rootScope.openCheckNewTab = function(id) {
    if (!id) return;
    const pathStateWithQuery = $rootScope.getCheckPageURL(id);
    window.open(pathStateWithQuery, "_blank");
  }

  $rootScope.handleOpenInvoiceModal = function({ invoiceId, forceModal }) {
    $rootScope.invoiceModalInstance = $uibModal.open({
      templateUrl: 'admin/views/billing-invoice-details-main.html',
      size: 'lg',
      backdrop: true,
      controller: 'billingInvoiceDetailsCtrl',
      windowClass: "modal modal-slide-in-right invoice-modal",
      resolve: {
        invoice: () => ( { id: invoiceId })
      }
    });

    $rootScope.invoiceModalInstance.result
        .finally(() => $state.go($state.current.name, { invoice: null }, { reload: false }));
  };

  $rootScope.closeInvoiceModal = function() {
    if ($rootScope.invoiceModalInstance && $rootScope.invoiceModalInstance.opened.$$state.value) {
      $rootScope.invoiceModalInstance.close()
    }
  };

  $rootScope.getPayrollBatchPageURL = (id) => {
    if (!id) return;
    return window.location.protocol +
      "//" +
      window.location.host +
      '/app/payroll/payrolls/' +
      id;
  };

  $rootScope.openPayrollBatchNewTab = (id) => {
    if (!id) return;
    const pathStateWithQuery = $rootScope.getPayrollBatchPageURL(id);
    window.open(pathStateWithQuery, "_blank");
  };

  $rootScope.openVideosModal = function(caregiverWithVideos) {

    var modalInstance = $uibModal.open({
      templateUrl: 'admin/views/videos-modal.html',
      size: 'lg',
      controller: 'videosModalCtrl',
      resolve: {
        caregiverWithVideos: function() {
          return (caregiverWithVideos);
        }
      }
    });
  };

  $rootScope.openVideoSessionsModal = function(video) {

    var modalInstance = $uibModal.open({
      templateUrl: 'admin/views/video-sessions-modal.html',
      size: 'lg',
      controller: 'videoSessionsModalCtrl',
      windowClass: 'top-top-top',
      resolve: {
        video: function() {
          return (video);
        }
      }
    });
  };

  $rootScope.openCalendarNewVisitModal = function(data) {
    return ($uibModal.open({
      templateUrl: 'admin/views/calendar-new-visit-modal.html',
      size: 'md',
      controller: 'calendarNewVisitModalCtrl',
      windowClass: 'calendar-new-visit-modal',
      resolve: {
        data: function() {
          return (data);
        }
      }
    }).result);
  };

  $rootScope.openNewTextNoteModal = function(newScope) {

    return (
      $uibModal.open({
        templateUrl: 'admin/views/create-simple-note-modal.html',
        size: 'md',
        controller: 'createSimpleNoteModalCtrl',
        scope: newScope,
        windowClass: "modal modal-slide-in-right create-note-container"
      }).result
    );
  };

  $rootScope.openNewAdjustmentApprovalNoteModal = function(newScope) {
    newScope.skipSaving= true;
    newScope.okButton= 'Yes, save changes and post note';
    newScope.description= 'The visit instance is billed or paid. Please post a note in order to save changes.';
    newScope.title= 'Are you sure you want to save changes?';
    newScope.note = {
      ...newScope.note,
      status: "NONE",
      noteRichText: "",
      noteType: noteConsts.NoteTypes.ADJUSTMENT_APPROVAL,
    }

    return (
      $uibModal.open({
        templateUrl: 'admin/views/create-simple-note-modal.html',
        size: 'md',
        controller: 'createSimpleNoteModalCtrl',
        scope: newScope,
        windowClass: "modal create-note-container-center top-top-top"
      }).result
    );
  };

  $rootScope.openNewVisitInstanceNoteModal = function(newScope) {
    newScope.note = {
      ...newScope.note,
      status: "NONE",
      noteRichText: "",
      noteType: noteConsts.NoteTypes.VISIT_INSTANCE
    }

    return (
      $uibModal.open({
        templateUrl: 'admin/views/create-simple-note-modal.html',
        size: 'md',
        controller: 'createSimpleNoteModalCtrl',
        scope: newScope,
        windowClass: "modal modal-slide-in-right create-note-container"
      }).result
    );
  };

  $rootScope.openNewCalendarNoteModal = function(newScope) {
    newScope.note = {
      ...newScope.note,
      status: "NONE",
      noteRichText: "",
      noteType: noteConsts.NoteTypes.CALENDAR
    }

    return (
      $uibModal.open({
        templateUrl: 'admin/views/create-simple-note-modal.html',
        size: 'md',
        controller: 'createSimpleNoteModalCtrl',
        scope: newScope,
        windowClass: "modal modal-slide-in-right create-note-container"
      }).result
    );
  };
  
  $rootScope.openUploadDocumentPdfModal = function(data) {
    return ($uibModal.open({
      templateUrl: 'admin/views/upload-document-pdf-modal.html',
      size: 'md',
      controller: 'uploadDocumentPdfModalCtrl',
      windowClass: 'upload-document-pdf-modal',
      resolve: {
        data: function() {
          return (data);
        }
      }
    }).result);
  };

  $rootScope.openNewPatientIntakeNoteModal = async function ({ patientId, onClose }) {
    const newScope = $rootScope.$new();

    newScope.note = {
      agencyMembers: [],
      patientId: patientId,
      noteType: noteConsts.NoteTypes.PROFILE_NOTE,
      subject: {
        name: "Intake"
      }
    };
    newScope.preSelected = {
      patientId: patientId,
    };

    const modal = $uibModal.open({
      templateUrl: "admin/views/create-note-modal.html",
      size: "md",
      controller: "createNoteModalCtrl",
      scope: newScope,
      windowClass: "modal modal-slide-in-right create-note-container",
    })

    modal.result.then(onClose, onClose);
  };

  $rootScope.getPatientPageURL = function(id) {
    if (isMissingEntityModalId(id)) return;

    return window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?patient=${id}`;
  }

  function getPatientModalRoute(id) {
    const rawId = String(id);

    const numericId = Number(rawId);

    // A negative id is the explicit "show me the legacy window for this patient"
    // override used while the beta window is being built; it ignores the setting.
    if (Number.isFinite(numericId) && numericId < 0) {
      return {
        id: Math.abs(numericId),
        key: rawId,
        templateUrl: "admin/views/patient-modal.html",
        useReact: false,
      };
    }

    const id_ = Number.isFinite(numericId) ? numericId : id;

    // Ordinary ids follow the user's profile window setting, which defaults to
    // the legacy window.
    return isBetaProfileWindowEnabled()
      ? {
          id: id_,
          key: rawId,
          templateUrl: "admin/views/react-patient-modal.html",
          useReact: true,
        }
      : {
          id: id_,
          key: rawId,
          templateUrl: "admin/views/patient-modal.html",
          useReact: false,
        };
  }

  $rootScope.openPatientModal = function(id, forceModal, { redirect, onClose } = { redirect: true }) {
    if (isMissingEntityModalId(id)) return;

    if (redirect) {
      const pathStateWithQuery = $rootScope.getPatientPageURL(id);

      window.history.pushState({
        path: pathStateWithQuery
      }, "", pathStateWithQuery);
    } else {
      $rootScope.allowPatientModalWithoutQueryParam = true;
    }

    $rootScope.handleOpenPatientModal(id, forceModal, onClose);
  }

  // What the patient modal can do for the AI omnibar, described where it is opened.
  registerAiCapability(
    {
      id: "patient.openModal",
      title: "Open a patient's profile",
      effect: "navigate",
      description:
        "Opens the full patient profile as a slide-in modal over whatever page the user is on, with their calendar, visits, authorizations, notes and documents.",
      location: "a slide-in modal, reachable from any page",
      // Opening this modal puts the user inside the patient profile. What lives in there is up to
      // the components that render there; this one does not know and does not need to.
      opens: ["patient-profile"],
      params: [
        {
          name: "patient",
          type: "patientRef",
          required: true,
          description: "Which patient: their id as shown in the app, or their name."
        }
      ],
      examples: ["open patient 2", "show me Jane Doe's profile"]
    },
    (args, context) => {
      $rootScope.openPatientModal(args.patient);

      return "Opened " + (context.labels.patient ?? "the patient");
    }
  );

  $rootScope.openPatientPocHistoryModal = function(patient, forceModal) {
    if (!patient) return;

    $rootScope.handleOpenPatientPocHistoryModal(patient, forceModal);
  }

  $rootScope.handleOpenPatientPocHistoryModal = function(patient) {
    $rootScope.patientPocHistoryModalInstance = $uibModal.open({
      templateUrl: 'admin/views/patient-poc-history-modal.html',
      size: 'lg',
      backdrop: true,
      controller: 'patientPocHistoryCtrl',
      controllerAs: "ctrl",
      windowClass: "modal modal-slide-in-right patient-modal patient-poc-history-modal",
      resolve: {
        patient: patient,
      }

    });
  };

  $rootScope.openPatientNewTab = function(id) {
    if (isMissingEntityModalId(id)) return;

    let pathStateWithQuery = $rootScope.getPatientPageURL(id);

    window.open(pathStateWithQuery, "_blank");
  }

  $rootScope.clearPatientPageURL = function() {
    const url = new URL(window.location.href);
    url.searchParams.delete('patient');

    window.history.replaceState({
      path: url.toString()
    }, "", url.toString());
  }

  $rootScope.markEntityModalContentReady = function() {
    $rootScope.$evalAsync(() => {
      $rootScope.isEntityModalContentBlocked = false;
      // The modal's critical window is over — let the deferred navbar badge
      // fetches run now.
      $rootScope.flushNavbarBadges();
    });
  }

  $rootScope.handleOpenPatientModal = function(id, forceModal, onClose) {
    const patientModalRoute = getPatientModalRoute(id);

    if (
      $rootScope.currentOpenedPatientIdModal &&
      $rootScope.currentOpenedPatientIdModal !== patientModalRoute.key
    ) {
      $rootScope.closePatientModal(true);
    }

    if ($rootScope.currentOpenedPatientIdModal === patientModalRoute.key) {
      return;
    }

    if (!$rootScope.currentOpenedPatientIdModal) {
      $rootScope.currentOpenedPatientIdModal = patientModalRoute.key;
      $rootScope.isEntityModalContentBlocked = patientModalRoute.useReact;
      $rootScope.patientModalInstance = $uibModal.open({
        templateUrl: patientModalRoute.templateUrl,
        size: 'lg',
        backdrop: true,
        controller: patientModalRoute.useReact
          ? ["$scope", "id", "DatabaseApi", "entityNotesModalService", "entityNewVisitModalService", function($scope, id, DatabaseApi, entityNotesModalService, entityNewVisitModalService) {
            const getPatientChats = (patientId) => {
              // Beta resolves participants; legacy reuses its caregiver dictionary.
              const caregivers = {};
              let caregiversWithNoChatWithUser = [];
              const emptyDate = JSON.stringify(new Date('1/1/1980')).slice(1, -1);

              DatabaseApi.get('agencies/' + $rootScope.agencyId + '/chat_rooms/' + $rootScope.agencyMemberId)
              .then((res) => DatabaseApi.chatCaregivers(res.data.chatRooms).then((rows) => ({ data: res.data, rows })))
              .then(({ data, rows }) => {
                if (!data || !data.chatRooms) {
                  return;
                }
                rows.forEach((caregiver) => {
                  caregivers[caregiver.id.toString()] = caregiver;
                  caregiversWithNoChatWithUser.push(caregiver.id);
                });

                const patientChats = [];

                data.chatRooms.forEach((chat) => {
                  if (chat.chatRoomType.type !== "CaregiverPatientChat") {
                    return;
                  }
                  if (Number(chat.chatRoomType.patientId) !== Number(patientId)) {
                    return;
                  }
                  if (!caregivers[chat.chatRoomType.caregiverId]) {
                    return;
                  }

                  const caregiverId = chat.chatRoomType.caregiverId;
                  const chatLine = angular.copy(caregivers[caregiverId]);
                  chatLine.chat = chat;
                  caregiversWithNoChatWithUser = caregiversWithNoChatWithUser.filter((id) => id !== caregiverId);

                  let lastViewed;
                  if (chat.members) {
                    chat.viewed = null;
                    chat.members.forEach((member) => {
                      if (member.user.type === 'AgencyMember') {
                        if (member.lastViewed > lastViewed || !lastViewed) {
                          lastViewed = member.lastViewed;
                        }
                      } else {
                        chat.viewed = member.lastViewed;
                      }
                    });
                  }

                  let notViewedCounter = 0;
                  if (chat.messages && chat.messages.length) {
                    chatLine.lastMessage = chat.messages[chat.messages.length - 1].createdAt;
                    if (lastViewed) {
                      for (let i = chat.messages.length - 1; i >= 0; i--) {
                        if (!chat.messages[i].broadcast && chat.messages[i].createdAt > lastViewed) {
                          notViewedCounter++;
                        } else {
                          break;
                        }
                      }
                    } else if (chat.messages[0].user.type === 'Caregiver') {
                      notViewedCounter++;
                    }
                    chat.notViewedCounter = notViewedCounter || 0;
                    chat.notViewedCounterBoolean = notViewedCounter > 0;
                    chatLine.notViewedCounterBoolean = notViewedCounter > 0;
                    if (notViewedCounter) {
                      $rootScope.commPageChatCounterCache[chat.id] = true;
                    } else {
                      delete $rootScope.commPageChatCounterCache[chat.id];
                    }
                  } else {
                    chatLine.lastMessage = emptyDate;
                  }

                  patientChats.push(chatLine);
                });

                caregiversWithNoChatWithUser.forEach((caregiverId) => {
                  const caregiver = angular.copy(caregivers[caregiverId.toString()]);
                  if (!caregiver) {
                    return;
                  }
                  caregiver.lastMessage = emptyDate;
                  caregiver.chat = undefined;
                  patientChats.push(caregiver);
                });

                $scope.reactPatientModal.patientChats = patientChats;
              });
            };

            const setNotesData = (notesType, calendarDay = undefined) => {
              entityNotesModalService.setNotesData({
                profileId: $scope.reactPatientModal.patientId,
                notesType,
                calendarDay
              });
            };

            const setNewVisitData = (calendarDate = undefined, visitData = {}) => {
              const patient = $scope.reactPatientModal.patient;
              entityNewVisitModalService.setNewVisitData({
                patientId: $scope.reactPatientModal.patientId,
                patient,
                patientStaffingPreferences: visitData.patientStaffingPreferences,
                patientAddress: patient.address,
                patientContracts: patient.contracts ?? [],
                patientMainLanguage: patient.mainLanguage,
                patientSecondaryLanguage: patient.secondaryLanguage,
                patientPhoneNumbers: patient.phoneNumbers ?? [],
                patientVacations: (patient.vacations ?? []).filter((vacation) => !vacation.removedAt),
                patientAuthorizations: visitData.patientAuthorizations ?? patient.authorizations,
                calendarDate
              });
            };

            $scope.reactPatientModal = {
              patientId: id,
              patient: { id },
              patientChats: undefined,
              currentPatientChat: undefined,
              sideBarState: undefined,
              handleChatClicked(chat) {
                $rootScope.openChat(chat);
              },
              clearSelectedChat() {
                $scope.reactPatientModal.currentPatientChat = undefined;
              },
              handleSideBarStateChange(newState, params = {}) {
                if (params.patient) {
                  $scope.reactPatientModal.patient = params.patient;
                }

                const secondClickDoesntCloseModals = ["NEW_VISIT", "EDIT_NEW_VISIT"];
                if (
                  (
                    $scope.reactPatientModal.sideBarState === newState &&
                    !secondClickDoesntCloseModals.includes(newState)
                  ) ||
                  $rootScope.isNewVisitSideModalOpen === false
                ) {
                  $scope.reactPatientModal.sideBarState = undefined;
                  $rootScope.isNewVisitSideModalOpen = undefined;
                  return;
                }

                switch (newState) {
                  case "CHATS":
                    if (!$scope.reactPatientModal.patientChats) {
                      getPatientChats($scope.reactPatientModal.patientId);
                    }
                    break;
                  case "NOTES":
                    setNotesData('Patient');
                    break;
                  case "CALENDAR":
                    setNotesData('PatientCalendar', params.calendarDay);
                    break;
                  case "NEW_VISIT":
                    if (params.calendarDate) {
                      setNewVisitData(params.calendarDate, params);
                    } else {
                      setNewVisitData(undefined, params);
                    }
                    $rootScope.$broadcast("calendar_new_visit");
                    break;
                  default:
                    break;
                }

                $scope.reactPatientModal.sideBarState = newState;
              }
            };

            const unsubscribeOpenSideBar = $scope.$on("react_patient_modal_open_side_bar", (_event, data) => {
              $scope.reactPatientModal.handleSideBarStateChange(data.state, data);
            });

            $scope.$on("$destroy", () => {
              entityNewVisitModalService.releasePatientWindow($scope.reactPatientModal.patient);
              unsubscribeOpenSideBar();
              $rootScope.isNewVisitSideModalOpen = undefined;
            });
          }]
          : "patientCtrl",
        windowClass: "modal modal-slide-in-right patient-modal",
        resolve: {
          id: function() {
            return patientModalRoute.id;
          },
          forceModal: function() {
            return forceModal;
          }
        }

      });

      $rootScope.patientModalInstance.result.finally(() => {
        $rootScope.isEntityModalContentBlocked = false;
        // First modal close: reveal the main ui-view (and keep it from now on).
        $rootScope.suppressMainView = false;
        // Safety net: if the modal never reported ready, the badges would otherwise
        // stay deferred forever. Idempotent, so harmless when ready already fired.
        $rootScope.flushNavbarBadges();
        onClose?.();
        $rootScope.allowPatientModalWithoutQueryParam = undefined;
        const patientParam = getParameterByName('patient');
        const caregiverParam = getParameterByName('caregiver');
        if (caregiverParam) {
          return;
        }
        if ($rootScope.previousOpenedPatientIdModal) {
          $rootScope.openPatientModal($rootScope.previousOpenedPatientIdModal);
          $rootScope.previousOpenedPatientIdModal = undefined;
        } else if (!patientParam) {
          $rootScope.closePatientModal();
        } else {
          $rootScope.currentOpenedPatientIdModal = undefined;
          $rootScope.clearPatientPageURL();
        }
      });
    }
  };

  $rootScope.closePatientModal = function(saveState = false) {
    if (saveState === true) {
      $rootScope.previousOpenedPatientIdModal = $rootScope.currentOpenedPatientIdModal;
    }
    $rootScope.isEntityModalContentBlocked = false;
    $rootScope.currentOpenedPatientIdModal = undefined;
    if ($rootScope.patientModalInstance && $rootScope.patientModalInstance.opened.$$state.value) {
      $rootScope.patientModalInstance.close();
    }
  };

  $rootScope.closeCaregiverModal = function() {
    $rootScope.isEntityModalContentBlocked = false;
    $rootScope.currentOpenedCaregiverIdModal = undefined;
    if ($rootScope.caregiverModalInstance && $rootScope.caregiverModalInstance.opened.$$state.value) {
      $rootScope.caregiverModalInstance.close()

      if ($rootScope.previousOpenedPatientIdModal) {
        $rootScope.openPatientModal($rootScope.previousOpenedPatientIdModal);
        $rootScope.previousOpenedPatientIdModal = undefined;
      }
    }
  };

  $rootScope.closePatientPocHistoryModal = function() {
    if ($rootScope.patientPocHistoryModalInstance && $rootScope.patientPocHistoryModalInstance.opened.$$state.value) {
      $rootScope.patientPocHistoryModalInstance.close();
    }
  };

  $rootScope.getVisitInstanceModalUrl = function(id, patientId) {
    if (!id) return;
    const url = window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?visitInstance=${id}`;

    return patientId ? `${url}&visitInstancePatient=${patientId}` : url;
  }

  $rootScope.openVisitInstanceModal = function(visitInstanceId, patientId, { redirect, onClose } = { redirect: true }) {
    let pathStateWithQuery = $rootScope.getVisitInstanceModalUrl(visitInstanceId, patientId);

    if (redirect) {
      window.history.pushState({ path: pathStateWithQuery }, "", pathStateWithQuery);
    } else {
      $rootScope.allowVisitInstanceModalWithoutQueryParam = true;
    }

    return $rootScope.handleOpenVisitInstanceModal(visitInstanceId, patientId, onClose);
  };

  $rootScope.openVisitInstanceModalNewTab = function(visitInstanceId, patientId) {
    if (!visitInstanceId) return;

    let pathStateWithQuery = $rootScope.getVisitInstanceModalUrl(visitInstanceId, patientId);

    window.open(pathStateWithQuery, "_blank");
  }

  $rootScope.handleOpenVisitInstanceModal = function(visitInstanceId, patientId, onClose) {
    $rootScope.visitInstanceModalInstance = $uibModal.open({
        templateUrl: 'admin/views/visit-instance-modal.html',
        size: 'lg',
        controller: 'visitInstanceModalCtrl',
        backdrop: true,
        resolve: {
          visitId: () => visitInstanceId,
          patientId: () => patientId,
        }
      });

    $rootScope.visitInstanceModalInstance.result
        .finally(() => {
          onClose?.();
          $rootScope.allowVisitInstanceModalWithoutQueryParam = undefined;
          return $state.go($state.current.name, { visitInstance: null }, { reload: false })
        });

    return $rootScope.visitInstanceModalInstance;
  };

  $rootScope.closeVisitInstanceModal = function() {
    if ($rootScope.visitInstanceModalInstance && $rootScope.visitInstanceModalInstance.opened.$$state.value) {
      $rootScope.visitInstanceModalInstance.close()
    }
  };

  $rootScope.handleOpenVisitBroadcastModal = function(visitBroadcastId) {
    $rootScope.visitBroadcastModalInstance = $uibModal.open({
        templateUrl: 'admin/views/visit-modal.html',
        size: 'lg',
        windowClass: 'modal-slide-in-right visit-modal-window',
        controller: 'visitModalCtrl',
        backdrop: true,
        resolve: {
          hasIdOnly: () => true,
          visit: () => ({ id: visitBroadcastId }),
        }
      });

      $rootScope.visitBroadcastModalInstance.result.catch(e => {
        if (["cancel", "backdrop click"].includes(e)) {
            $state.go("^");
        }
      });

    return $rootScope.visitBroadcastModalInstance;
  };

  $rootScope.closeVisitBroadcastModal = function() {
    if ($rootScope.visitBroadcastModalInstance && $rootScope.visitBroadcastModalInstance.opened.$$state.value) {
      $rootScope.visitBroadcastModalInstance.close()
    }
  };

  $rootScope.openBulkVisitInstancesModal = function(visitInstanceIds) {
    return $uibModal.open({
      templateUrl: 'admin/views/visit-instance-modal.html',
      size: 'lg',
      controller: 'visitInstanceModalCtrl',
      backdrop: true,
      resolve: {
        visitInstanceIds: () => visitInstanceIds
      }
    });
  };

  $rootScope.getCAgencyMemberName = function(id) {
    var coordinators = DatabaseApi.getAgencyMembers();

    if (coordinators[id]) return coordinators[id];
    return '';
  };

  $rootScope.openVisitBroadcastModalById = (visitBroadcastId, { onClose } = {}) => {
    DatabaseApi.getVisit(visitBroadcastId).then((visit) => {
      visit.status = VisitStatus.getVisitStatus(visit);
      $rootScope.openVisitModal({ visit, onClose })
    }, (err) => {
      toaster.pop("error", "Oops...", "Can't open visit broadcast modal");
    });
  };

  $rootScope.openVisitModal = ({
    visit,
    onClose
  }) => {
    $state.go('app.visits.dashboard.item', { broadcast: visit.id });
  }

  $rootScope.openDocumentPreviewModalById = (docId) => {

    let newScope = $rootScope.$new();
    newScope.document = {id: docId};
    newScope.url = 'agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId +'/faxes/' + docId;

    $uibModal.open({
        templateUrl: 'admin/views/image-viewer-modal.html',
        size: 'lg',
        controller: 'imageViewerModalCtrl',
        scope: newScope
    });
  }

  $rootScope.dropdownSettings = dropdownSettingsConsts;

  /*

    $rootScope.countDownSweepTimer = function () {


      var newYork = new Date().toLocaleString('en-US', {hour: '2-digit', hour12: false});
      var local = new Date().toLocaleString('en-US', {hour: '2-digit', hour12: false});


      if (newYork.search(':') > -1) {
        newYork = newYork.split(':')[0].toString();
        local = local.split(':')[0].toString();
      }

      var dif = parseInt(local.replace(/[^\d]/, "")) - parseInt(newYork.replace(/[^\d]/, ""));
      var nowZero = new Date().setHours(dif, 0, 0, 0);


      var end = setDay(new Date(nowZero), 0);

      var _second = 1000;
      var _minute = _second * 60;
      var _hour = _minute * 60;
      var _day = _hour * 24;
      var timer;

      function showRemaining() {
        var now = new Date();
        var distance = end - now;
        //console.log(end);
        //console.log(now);


        if (distance < 0) {

          $rootScope.sweepCounter = {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00'
          };

          return;
        }

        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        if (hours < 10) hours = '0' + hours;
        if (minutes < 10) minutes = '0' + minutes;
        if (seconds < 10) seconds = '0' + seconds;

        $rootScope.sweepCounter = {
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        };

        ////console.log($rootScope.sweepCounter);

      }

      $interval(showRemaining, 1000);

    };

    function setDay(date, dayOfWeek) {
      date = new Date(date.getTime());
      date.setDate(date.getDate() + (dayOfWeek + 7 - date.getDay()) % 7);
      return date;
    }

    $rootScope.countDownSweepTimer();
  */


  ////
  ////
  ////


  //  var _second = 1000;
  //  var _minute = _second * 60;
  //  var _hour = _minute * 60;
  //  var _day = _hour * 24;
  //  var timer;

  //  // var twoWeeks = 60 * 60 * 24 * 14 * 1000;
  //  var arbitraryEndTime = new Date(
  //      new Date(
  //          new Date(
  //              new Date(
  //                  new Date(
  //                     new Date()
  //                      .setFullYear(2019))
  //                      .setMonth(8))
  //                      .setDate(30))
  //                      .setHours(0))
  //                      .setMinutes(0))
  //                      .setSeconds(0);

  //  console.log(arbitraryEndTime);
  //  /*while (new Date().getTime() > arbitraryEndTime) {
  //    // arbitraryEndTime = arbitraryEndTime + twoWeeks;
  //  }*/

  //  function countDown() {
  //    var distance = arbitraryEndTime - new Date().getTime();

  //    var days = Math.floor(distance / _day);
  //    var hours = Math.floor((distance % _day) / _hour);
  //    var minutes = Math.floor((distance % _hour) / _minute);
  //    var seconds = Math.floor((distance % _minute) / _second);

  //    if (distance < 0) {
  //      // arbitraryEndTime = arbitraryEndTime + twoWeeks;
  //      return;
  //    }

  //    if (hours < 10) hours = '0' + hours;
  //    if (minutes < 10) minutes = '0' + minutes;
  //    if (seconds < 10) seconds = '0' + seconds;

  //    $rootScope.sweepCounter = {
  //      days: days,
  //      hours: hours,
  //      minutes: minutes,
  //      seconds: seconds
  //    };

  //  };
  //  $interval(countDown, 1000);

  /*

       function countDown() {
         var distance = new Date('08/24/2018') - new Date().getTime();

         var days = Math.floor(distance / _day);
         var hours = Math.floor((distance % _day) / _hour);
         var minutes = Math.floor((distance % _hour) / _minute);
         var seconds = Math.floor((distance % _minute) / _second);

         if (distance < 0) {
           days = '0';
           hours = '00';
           minutes = '00';
           seconds = '00';
           return;
         }

         if (hours < 10) hours = '0' + hours;
         if (minutes < 10) minutes = '0' + minutes;
         if (seconds < 10) seconds = '0' + seconds;

         $rootScope.sweepCounter = {
           days: days,
           hours: hours,
           minutes: minutes,
           seconds: seconds
         };

       };
       $interval(countDown, 1000);

  */


  /*var modalInstance = $uibModal.open({
      templateUrl: 'admin/views/visit-suggest-modal.html',
      size: 'lg',
      controller: 'visitSuggestModalCtrl',
      resolve: {
          visit: function () {
              return {};
          }

      }

  });
  modalInstance.result.then(function (res) {
      console.log('modal click');
      console.log(res);
      //createVisit(res);
  }, function () {
      console.log('modal close');
  });*/

  /*
      $timeout(function () {


          var modalInstance = $uibModal.open({
              templateUrl: 'admin/views/rn-visit-map-modal.html',
              size: 'lg',
              controller: 'rnVisitMapModalCtrl'

          });
          modalInstance.result.then(function (res) {
              console.log('modal out');
              //console.log(res);
          }, function () {
              console.log('modal close');
          });

      },3000);*/

  $rootScope.openOvertimeCalculatorModal = function() {
    $uibModal.open({
      templateUrl: "admin/views/overtime-calculator-modal.html",
      size: 'md',
      controller: 'overtimeCalculatorModalCtrl'
    });
  }

  $rootScope.openNoteCreateModal = function(isBulk) {
    const newScope = $rootScope.$new();
    newScope.isBulk = isBulk;

    const modalInstance = $uibModal.open({
      templateUrl: 'admin/views/create-note-modal.html',
      size: 'md',
      controller: 'createNoteModalCtrl',
      resolve: { },
      scope: newScope,
      windowClass: "modal modal-slide-in-right create-note-container"
    });

    return modalInstance;
  }

  $rootScope.openSavedReportPermissionsModal = function(newScope) {
    const modalInstance = $uibModal.open({
      templateUrl: 'admin/views/saved-report-permissions-modal.html',
      size: 'md',
      controller: 'savedReportPermissionsModalCtrl',
      scope: newScope,
      windowClass: 'modal modal-slide-in-right saved-report-permissions-container',
      backdrop: 'static',
      keyboard: false
    });

    return modalInstance;
  };
  $rootScope.openStandardReportPermissionsModal = function(newScope) {
    const modalInstance = $uibModal.open({
      templateUrl: 'admin/views/standard-report-permissions-modal.html',
      size: 'md',
      controller: 'standardReportPermissionsModalCtrl',
      scope: newScope,
      windowClass: 'modal modal-slide-in-right saved-report-permissions-container',
      backdrop: 'static',
      keyboard: false
    });

    return modalInstance;
  };
  $rootScope.openStandardReportHiddenModal = function(newScope) {
    const modalInstance = $uibModal.open({
      templateUrl: 'admin/views/standard-report-hidden-modal.html',
      size: 'md',
      controller: 'savedReportPermissionsModalCtrl',
      scope: newScope,
      windowClass: 'modal modal-slide-in-right saved-report-permissions-container',
      backdrop: 'static',
      keyboard: false
    });

    return modalInstance;
  };


  $rootScope.openReportEntityPermissionsModal = function() {
    const modalInstance = $uibModal.open({
      templateUrl: 'admin/views/report-entity-permissions-modal.html',
      size: 'md',
      controller: 'reportEntityPermissionsModalCtrl',
      windowClass: 'modal modal-slide-in-right report-entity-permissions-container',
      backdrop: 'static',
      keyboard: false
    });

    return modalInstance;
  };


  $rootScope.navigationItems = {
    dashboard: {
      title: 'Dashboard',
      stateName: 'app.dashboard',
      sectionName: 'dashboard',
      iconPath: 'admin/images/icons/dashboard.svg',
      permissionKey: 'view_dashboard_section',
      subItems: [{
          text: 'Caregivers',
          stateName: 'app.dashboard.caregivers',
          permissionKey: 'view_dashboard_section_caregivers'
        },
        {
          text: 'Online',
          stateName: 'app.dashboard.online',
          permissionKey: 'view_dashboard_section_online'
        },
        {
          text: 'Installations',
          stateName: 'app.dashboard.installations',
          permissionKey: 'view_dashboard_section_installations'
        },
        {
          text: 'Tutorials',
          stateName: 'app.tutorials',
          permissionKey: 'view_tutorials_section'
        },
        {
          text: 'Visit Statistics',
          stateName: 'app.dashboard.visitStatistics',
          permissionKey: 'view_dashboard_section_statistics'
        },
        {
          text: 'Coordinator Activity',
          stateName: 'app.dashboard.coordinatorActivity',
          permissionKey: 'view_dashboard_section_coordinator'
        }
      ]
    },
    notes: {
      title: 'Notes',
      label: "unread_count",
      stateName: 'app.notes',
      sectionName: 'notes',
      iconPath: 'admin/images/icons/notes-light.svg',
      subItems: [],
      permissionKey: 'view_notes_section'
    },
    recruitment: {
      title: 'Recruitment',
      stateName: 'app.recruitment',
      sectionName: 'recruitment',
      iconPath: 'admin/images/icons/recruitment.svg',
      subItems: [],
      permissionKey: 'view_recruitment_section'
    },
    passportVerifier: {
      title: 'Passport Verifier',
      stateName: 'app.passportVerifier',
      sectionName: 'passportVerifier',
      iconPath: 'admin/images/icons/medflyt-passport.svg',
      subItems: [],
      permissionKey: 'view_passport_verifier_section'
    },
    passport: {
      title: 'Passport',
      stateName: 'app.passport',
      sectionName: 'passport',
      iconPath: 'admin/images/icons/medflyt-passport.svg',
      subItems: [],
      permissionKey: 'view_passport_section'
    },
    patients: {
      title: 'Patients',
      stateName: 'app.patients',
      sectionName: 'patients',
      iconPath: 'admin/images/icons/patients.svg',
      permissionKey: 'view_patients_section',
      subItems: [{
          text: 'Patients list',
          permissionKey: 'view_patients_section_list',
          stateName: 'app.patients.dashboard',
        },
        {
          text: 'Care & Task management',
          permissionKey: 'view_patients_section_upcoming_tasks',
          stateName: 'app.patients.careAndTaskManagement'
        },
        {
          text: 'Service Plans',
          permissionKey: 'view_patient_page_cdsc_import',
          stateName: 'app.patients.servicePlans.imports',
          releaseDate: LocalDate.of(2026, 8, 17)
        },
        {
          text: 'Patient Alerts',
          permissionKey: 'view_patients_section_alerts',
          stateName: 'app.patients.patientAlerts'
        },
        {
          text: 'Quality Of Care',
          permissionKey: 'view_patients_section_medical_statistics',
          stateName: 'app.patients.medicalStatistics'
        },
        {
          text: 'Eligibility Checks',
          permissionKey: 'view_eligibility_checks',
          stateName: 'app.patients.eligibilityChecks',
          releaseDate: LocalDate.of(2022, 4, 15)
        },
        {
            text: 'Authorization Utilization (Beta)',
            permissionKey: 'view_authorization_utilization',
            stateName: 'app.authorization_utilization.dashboard',
            releaseDate: LocalDate.of(2026, 8, 17)
        }
      ]
    },
    caregivers: {
      title: 'Caregivers',
      // Points at whichever caregivers page the beta switch has active. The
      // Angular page only exists as a state while the improvements are off, so
      // naming it here unconditionally would give a dead link.
      stateName: useCaregiverMemoryImprovements ? 'app.caregiversNew' : 'app.professionals',
      sectionName: 'professionals',
      iconPath: 'admin/images/icons/caregivers.svg',
      permissionKey: 'view_caregivers_section',
      subItems: [{
          text: 'Caregivers list',
          permissionKey: 'view_caregivers_section_list',
          stateName: useCaregiverMemoryImprovements ? 'app.caregiversNew' : 'app.professionals.caregivers'
        },
        // The React list is registered whatever the switch says - only the
        // Angular one is conditional - so with the improvements off it is
        // reachable but has nothing pointing at it. This is that pointer: the
        // new list stays available to try without giving up the old one.
        ...(useCaregiverMemoryImprovements ? [] : [{
          text: 'Caregivers list (new)',
          permissionKey: 'view_caregivers_section_list',
          stateName: 'app.caregiversNew'
        }]),
        // Its own page again while the improvements are off: the React list folds
        // pending acceptance into a filter, the Angular one does not.
        ...(useCaregiverMemoryImprovements ? [] : [{
          text: 'Pending Acceptance',
          stateName: 'app.professionals.pendingAcceptance',
          permissionKey: 'view_caregivers_section_pending_acceptance',
          showViewByUserRole: 'pending'
        }]),
        {
          text: 'Onboarding',
          stateName: 'app.onboarding',
          permissionKey: 'view_caregivers_section_list',
        },
        {
          text: 'Compliance Tracking',
          permissionKey: 'view_caregivers_section_compliance',
          stateName: 'app.caregiversCompliance',
          releaseDate: LocalDate.of(2022, 5, 10),
        },
        {
          text: 'Caregivers Passport',
          permissionKey: 'view_caregivers_section_passport',
          stateName: 'app.passport'
        },
        // {
        //     text: 'PTO Approvals',
        //     stateName: 'app.ptoApprovals',
        //     permissionKey: 'view_caregivers_section_pto_approvals',
        //     billing: true
        // }
        {
          text: 'Exclusions',
          stateName: 'app.exclusionLists',
          permissionKey: 'view_caregivers_section_list',
        },
      ]
    },
    trainingCenter: {
      title: 'Training Center',
      stateName: 'app.trainingCenter',
      sectionName: 'trainingCenter',
      iconPath: 'admin/images/icons/training-center.svg',
      permissionKey: 'view_caregivers_section_training_overview', // TODO change
      subItems: [{
          text: 'In-Service Overview',
          permissionKey: 'view_caregivers_section_training_overview',
          stateName: 'app.trainingCenter.caregiversTrainingCenterOverview'
        },
        {
          text: 'Enrollments Requests',
          stateName: 'app.trainingCenter.enrollmentsRequests'
        },
        {
          text: 'Active Bundles',
          stateName: 'app.trainingCenter.activeBundles'
        },
        {
          text: 'Orientation',
          stateName: 'app.orientationCenter'
        },
        {
          text: 'Bulk Exempts',
          stateName: 'app.trainingCenterExempts',
          permissionKey: 'view_caregiver_page_training_center'
        },
        // {
        //     text: 'Live Events',
        //     stateName: 'app.trainingCenter.liveEvents'
        // }
      ]
    },
    visits: {
      title: 'Visits',
      stateName: 'app.visits',
      sectionName: 'visits',
      iconPath: 'admin/images/icons/visits.svg',
      permissionKey: 'view_visits_section',
      subItems: [{
          text: 'Broadcasting activity',
          permissionKey: 'view_visits_section_list',
          stateName: 'app.visits.dashboard'
        },
        {
          text: 'Visit instances',
          permissionKey: 'view_visits_section_instances',
          stateName: 'app.visitInstances',
          billing: true,
          showViewByUserRole: 'visitInstances'
        },
        {
          text: 'Upload visit',
          permissionKey: 'view_visits_section_upload',
          stateName: 'app.visits.upload',
          hideForBilling: true,
        },
        {
          text: 'Duty Sheets',
          permissionKey: 'view_visits_section_duty_sheets',
          stateName: 'app.dutySheets'
        },
        {
          text: 'Time Sheets Approval',
          permissionKey: 'view_visits_section_duty_sheets',
          stateName: 'app.dutySheetsApprovals'
        },
        {
          text: 'Staffing Issues',
          permissionKey: 'view_visits_section_staffing_issues',
          stateName: 'app.staffingIssues'
        },
        {
          text: "Hours Usage",
          permissionKey: 'view_visits_section_staffing_issues',
          stateName: "app.hoursUsage"
        }
      ]
    },
    evv: {
      title: 'EVV',
      stateName: 'app.evv',
      sectionName: 'evv', // TODO change
      iconPath: 'admin/images/icons/call-darker.svg',
      permissionKey: 'view_evv_section',
      subItems: [{
          text: 'Clock in & out',
          permissionKey: 'view_evv_clock_in_out',
          stateName: 'app.evv.clockedVisits',
          allowedAgencies: [1, 7, 373, 1552, 3862, 4093, 3235, 5149, 5215, 4621, 1057, 5182, 6040, 5678, 2806, 5644, 6205, 6238, 5974, 4357, 6634, 4489]
        },
        {
          text: 'Clock in & out (New)',
          permissionKey: 'view_evv_clock_in_out',
          stateName: 'app.evv.clockedVisitsNew',
          allowedAgencies: [1, 7, 373, 1552, 3862, 4093, 3235, 5149, 5215, 4621, 1057, 5182, 6040, 5678, 2806, 5644, 6205, 6238, 5974, 4357, 6634, 4489]
        },
        {
          text: 'Calls',
          permissionKey: 'view_evv_calls',
          stateName: 'app.evv.calls',
          allowedAgencies: [1, 7, 373, 1552, 3862, 4093, 3235, 5149, 5215, 4621, 1057, 5182, 6040, 5678, 2806, 5644, 6205, 6238, 5974, 4357, 6634, 4489]
        }
      ]
    },
    payroll: {
      title: 'Payroll',
      stateName: 'app.payroll',
      sectionName: 'payroll', // TODO change
      iconPath: 'admin/images/icons/price-smaller.svg',
      permissionKey: 'view_payroll_section', // TODO change
      subItems: [{
          text: 'Payroll Batches',
          permissionKey: 'view_payroll_section_batches',
          stateName: 'app.payroll.batches',
        },
        {
          text: 'PTO Approvals',
          stateName: 'app.payroll.ptoApprovals',
          permissionKey: 'view_caregivers_section_pto_approvals'
        }
      ]
    },
    uploads: {
      title: 'Uploads',
      stateName: 'app.uploads.list',
      sectionName: 'uploads',
      iconPath: 'admin/images/icons/import.svg',
      subItems: [],
      permissionKey: 'view_uploads_section'
    },
    billing: {
      title: 'Billing',
      stateName: 'app.billing',
      sectionName: 'billing',
      iconPath: 'admin/images/icons/billing.svg',
      permissionKey: 'view_billing_section',
      subItems: [{
          text: 'Visits with issues',
          permissionKey: 'view_billing_section_visit_with_issues',
          stateName: 'app.billing.visitsWithIssues'
        },
        {
          text: 'Billable visits',
          permissionKey: 'view_billing_section_billable_visits',
          stateName: 'app.billing.newInvoiceBatch'
        },
        {
          text: 'Claims',
          permissionKey: 'view_billing_section_invoices',
          stateName: 'app.billing.invoices'
        },
        {
          text: 'Administrative Payments',
          permissionKey: 'view_billing_section_administrative_payment',
          stateName: 'app.administrative_payment.invoicing'
        },
        {
          text: 'Banked Minutes',
          permissionKey: 'view_billing_section_banked_minutes',
          stateName: 'app.banked_minutes.view'
        },
        {
          text: 'Adjustment Approvals',
          permissionKey: 'view_billing_section_adjustment_approvals',
          stateName: 'app.billing.visitAdjustmentApprovals'
        },
        // TEMP: Adjustment Approvals (New) sidebar entry disabled until perf is solved
        // {
        //   text: 'Adjustment Approvals (New)',
        //   permissionKey: 'view_billing_section_adjustment_approvals',
        //   stateName: 'app.billing.visitAdjustmentApprovalsNew'
        // },
        {
          text: 'Visits to export',
          permissionKey: 'view_billing_section_visits_to_export',
          stateName: 'app.billing.visitsToExport'
        },
        {
          text: 'Invoices to export',
          permissionKey: 'view_billing_section_visits_to_export',
          stateName: 'app.billing.invoicesToExport'
        },
        {
          text: 'Exports',
          permissionKey: 'view_billing_section_exports',
          stateName: 'app.billing.exports'
        },
        {
          text: 'Checks',
          permissionKey: 'view_billing_section_checks',
          stateName: 'app.billing.checks'
        },
        {
          text: 'AR',
          permissionKey: 'view_billing_section_ar',
          stateName: 'app.billing.accountsReceivable'
        },
        {
          text: 'Surplus',
          permissionKey: 'view_billing_section',
          stateName: 'app.billing.surpluses'
        },
        {
          text: '837 EDI Comparison',
          permissionKey: 'view_billing_section_837_edi',
          stateName: 'app.billing.ediComparison'
        }
        // {
        //     text: '835 EDI Conversion',
        //     permissionKey: 'view_billing_section_835_edi',
        //     stateName: 'app.billing.claimsConversion'
        // },

      ]
    },
    calls: {
      title: 'Calls Dashboard',
      stateName: 'app.calls',
      sectionName: 'calls',
      iconPath: 'admin/images/icons/calls-management.svg',
      permissionKey: 'view_calls_section',
      subItems: [{
          text: 'Calls Maintenace',
          permissionKey: 'view_calls_section_maintenance',
          stateName: 'app.calls.maintenance'
        },
        {
          text: 'Rejected Calls',
          permissionKey: 'view_calls_section_rejected',
          stateName: 'app.calls.rejected'
        },
        {
          text: 'Missed In',
          permissionKey: 'view_calls_section_missed_in',
          stateName: 'app.calls.missedIn'
        },
        {
          text: 'Missed Out',
          permissionKey: 'view_calls_section_missed_out',
          stateName: 'app.calls.missedOut'
        },
        {
          text: 'Missed Both',
          permissionKey: 'view_calls_section_missed_both',
          stateName: 'app.calls.missedBoth'
        }
      ]
    },
    visitEditRequests: {
      title: 'Edit Requests',
      stateName: 'app.visitEditRequests',
      sectionName: 'visitEditRequests',
      iconPath: 'admin/images/icons/edit-requests.svg',
      subItems: [],
      permissionKey: 'view_edit_requests_section'
    },
    communication: {
      title: 'Chat',
      stateName: 'app.communication',
      sectionName: 'communication',
      iconPath: 'admin/images/icons/communication.svg',
      subItems: [],
      permissionKey: 'view_communication_section'
      //     {
      //         text: 'Chat',
      //         stateName: 'app.communication'
      //     },
      //     {
      //         text: 'Broadcast',
      //         // stateName: 'app.communication'
      //     },
      //     {
      //         text: 'Boost App Downloads',
      //         // stateName: 'app.communication'
      //     }
      // ]
    },
    commcenter: {
        title: 'Comm Center',
        stateName: 'app.commcenter',
        sectionName: 'commcenter',
        iconPath: 'admin/images/icons/broadcast.svg',
        subItems: [{
          text: 'Comm Center',
          stateName: 'app.commcenter',
          permissionKey: 'view_communication_center'
        },
        {
          text: 'Fax Dashboard',
          stateName: 'app.faxes',
          permissionKey: 'view_communication_center'
        },],
        permissionKey: 'view_communication_center'
      },
      workflows: {
        title: 'Workflows',
        stateName: 'app.workflows',
        sectionName: 'workflows',
        iconPath: 'admin/images/icons/workflows.svg',
        subItems: [
          {
            text: 'Tasks',
            stateName: 'app.workflow_tasks',
            permissionKey: 'view_workflow_task'
          },
          {
            text: 'Task Viewer',
            stateName: 'app.workflow_task_viewer',
            permissionKey: 'workflow_task_viewer'
          },
          {
            text: 'Skills',
            stateName: 'app.workflow_skills',
            permissionKey: 'manage_workflow_skills'
          }
        ],
        permissionKey: 'view_workflows'
      },
    // analytics: {
    //     title: 'Analytics',
    //     stateName: 'app.analyticReports',
    //     sectionName: 'analytics',
    //     iconPath: 'admin/images/icons/analytics.svg',
    //     permissionKey: 'view_analytics_section',
    //     subItems: []
    // },
    admin: {
      title: 'Admin',
      stateName: 'app.settings',
      sectionName: 'admin',
      iconPath: 'admin/images/icons/admin.svg',
      subItems: [{
          text: 'Visit Settings',
          stateName: 'app.settings',
          permissionKey: 'view_admin_section_settings'
        },
        {
          text: 'HR Settings',
          stateName: 'app.hrSettings',
          showViewByUserRole: 'hrSettings',
          permissionKey: 'view_admin_section_hr'
        },
        {
          text: 'Notes Settings',
          stateName: 'app.notesSettings',
          permissionKey: 'view_admin_section_notes'
        },
        {
          text: 'Training Center Settings',
          stateName: 'app.trainingCenterSettings',
          showViewByUserRole: 'hrSettings',
          permissionKey: 'view_admin_section_training'
        },
        {
          text: 'Clinical & Care settings',
          stateName: 'app.patientDocumentSettings',
          permissionKey: 'view_admin_section_patient_documents'
        },
        {
          text: 'Team Members',
          stateName: 'app.invite',
          permissionKey: 'view_admin_section_members'
        },
        {
          text: 'Flyers',
          stateName: 'app.flyers',
          permissionKey: 'view_admin_section_flyers'
        },
        {
          text: 'Billing Info',
          stateName: 'app.payment',
          permissionKey: 'view_admin_section_billing'
        },
        {
          text: 'Analytics',
          stateName: 'app.analyticReports',
          permissionKey: 'view_analytics_section'
        }
      ],
      permissionKey: 'view_admin_section',
    },
    reports: {
      title: 'Reports',
      stateName: 'app.reports',
      sectionName: 'reports',
      iconPath: 'admin/images/icons/reports.svg',
      permissionKey: 'view_reports_section',
      subItems: [
        {
          text: 'Standard',
          permissionKey: 'view_reports_section_standard',
          stateName: 'app.reports.standard',
          billing: true

        },
        {
            text: 'Advanced',
            permissionKey: 'view_reports_section_advanced',
            stateName: 'app.reports.savedReports',
            billing: true,
            allowedAgencies: [5743, 5512, 5380]

          },
        {
          text: 'COVID-19 Reports',
          permissionKey: 'view_covid_section',
          stateName: 'app.reports.coronaVirusReports'
        }

      ]
    },
    agencies: {
      title: 'Agencies',
      stateName: 'app.agencies',
      sectionName: 'agencies',
      iconPath: 'admin/images/icons/engineering.svg',
      permissionKey: 'view_agencies_section',
      subItems: [{
          text: 'Customer Engagement',
          stateName: 'app.agencies.customerEngagement',
          permissionKey: 'view_agencies_section_customer_engagement'
        },
        {
          text: 'Engagement kpi',
          stateName: 'app.agencies.engagementKpi',
          permissionKey: 'view_agencies_section_engagement_kpi'
        }
      ]
    },
    hhaxIntegration:{
      title: 'HHAX Integration',
      stateName: 'app.hhax',
      sectionName: 'hhaxIntegration',
      iconPath: 'admin/images/icons/import.svg',
      permissionKey: 'view_hhax_integration_section',
      releaseDate: LocalDate.of(2022, 4, 12),
      subItems: [{
        text: 'Billing Rejections',
        stateName: 'app.hhax.billing',
        permissionKey: 'view_hhax_integration_section_billing'
      },
      {
        text: 'Non-Billing Records',
        stateName: 'app.hhax.nonBilling',
        permissionKey: 'view_hhax_integration_section_non_billing'
      },
      {
        text: 'Unlinked Patients',
        stateName: 'app.hhax.unlinkedPatients',
        permissionKey: 'view_hhax_integration_section_non_billing'
      }]
    },
  }

  function checkIsOnboardingAgencyId() {
    if (import.meta.env.MEDFLYT_AGENCY_ID) {
        return parseInt(import.meta.env.MEDFLYT_AGENCY_ID, 10) === $rootScope.agencyId
    }

    return $rootScope.agencyId === 10001;
  }

  function checkIsFreedomCareAgencyId() {
    return $rootScope.agencyId === 6205;
  }

  $rootScope.isOnboardingAgency = checkIsOnboardingAgencyId();
  $rootScope.isFCAgency = $rootScope.agencyId === 6205;
  $rootScope.isFreedomCareAgency = $rootScope.isFCAgency;
  $rootScope.visitTimeMinuteStep = $rootScope.isFCAgency ? 5 : 15;

  $rootScope.$watch("agencyId", () => {
    $rootScope.isOnboardingAgency = checkIsOnboardingAgencyId();
    $rootScope.isFCAgency = $rootScope.agencyId === 6205;
    $rootScope.isFreedomCareAgency = $rootScope.isFCAgency;
    $rootScope.visitTimeMinuteStep = $rootScope.isFCAgency ? 5 : 15;

    if ($rootScope.isOnboardingAgency) {
      if (import.meta.env.PROD) {
        console.log("[sentry]: initializing sentry");
        Sentry.init({
            dsn: "https://961a6fc1fc4f4f7a93eaa561c036918e@o64308.ingest.sentry.io/266156",
            initialScope: {
              user: {
                  agencyId: $rootScope.agencyId,
                  agencyMemberId: $rootScope.agencyMemberId,
                  userId: $rootScope.user.id,
                  email: $rootScope.user.email
              }
            },
            environment: "production",
            integrations: [
                new Sentry.BrowserTracing({
                  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
                  tracePropagationTargets: ["localhost", /^https:\/\/api\.medflyt\.com/],
                }),
                new Sentry.Replay({
                    maskAllInputs: false,
                    maskAllText: false
                })
            ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 0.6,

            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
      }

      if ($rootScope.isOnboardingAgency) {
        $rootScope.navigationItems.patients.subItems.push({
            text: 'Prompt Testing',
            stateName: 'app.patients.promptTesting',
        });  
      }

      $rootScope.navigationItems.patients.subItems.push({
          text: 'Intake',
          stateName: 'app.patients.intake.dashboard',
          permissionKey: 'view_patient_page_intake'
      });

      $rootScope.navigationItems.caregivers.subItems.push({
        text: "Prioritized caregivers",
        stateName: "app.caregiversPrioritized",
      });

      $rootScope.navigationItems.caregivers.subItems.push({
        text: 'Supplies Shipments',
        stateName: 'app.caregiver_supplies_shipments'
      });

      $rootScope.navigationItems.complianceDocumentReview = {
        title: "Compliance Document Review",
        stateName: "app.complianceDocumentReview",
        sectionName: "complianceDocumentReview",
        iconPath: "admin/images/icons/notes-dark.svg",
        permissionKey: "review_caregiver_compliance_document",
        subItems: [
          {
            text: "Compliance Document Review",
            stateName: "app.complianceDocumentReview.complianceDocumentReview",
            permissionKey: "review_caregiver_compliance_document",
          },
        ],
      };

      if ($rootScope.isOnboardingAgency) {
        $rootScope.navigationItems.caregivers.subItems.push({
          text: "AI Review Manual Check",
          stateName: "app.caregiversAiReviewManualCheck",
        });
      }

      $rootScope.navigationItems.visits.subItems.push({
        text: 'Assignments',
        stateName: 'app.visitAssignments'
      });

      $rootScope.navigationItems.patients.subItems.push({
        text: 'Authorized Patients Without Visits',
        stateName: 'app.patients.authorizedWithoutVisits',
      });

      $rootScope.navigationItems.patients.subItems.push({
        text: 'Patients Compliance',
        stateName: 'app.patients-compliance',
      });

      $rootScope.navigationItems.patients.subItems.push({
        text: 'Patient Issues',
        stateName: 'app.patients.patientIssues',
        permissionKey: 'view_patient_issues',
      });

      $rootScope.navigationItems.caregivers.subItems.push({
        text: "HCR State Compliance",
        stateName: "app.caregivers_hcr_compliance",
      });

      $rootScope.navigationItems.caregivers.subItems.push({
        text: "CHRC State Compliance",
        stateName: "app.caregivers_chrc_compliance",
      });
      
      $rootScope.navigationItems.caregivers.subItems.push({
        text: "State Compliance Issues",
        stateName: "app.caregivers_state_compliance_issues",
      });
    }

    // EVV Dev Help is for the FreedomCare members the server marks as developers. It has no
    // permission key or agency list: the server's `canManage` is the only rule, and the
    // item stays out of the menu until that answer arrives (and on any error).
    if ($rootScope.agencyId && $rootScope.agencyMemberId) {
      DatabaseApi.get(
        'agencies/' + $rootScope.agencyId + '/agency_members/' +
        $rootScope.agencyMemberId + '/evv_dev_help_requests/availability'
      ).then(function (res) {
        if (!res || !res.data || res.data.canManage !== true) {
          return;
        }

        var alreadyListed = $rootScope.navigationItems.evv.subItems.some(function (item) {
          return item.stateName === 'app.evv.devHelp';
        });

        if (alreadyListed) {
          return;
        }

        $rootScope.navigationItems.evv.subItems.push({
          text: 'EVV Dev Help',
          stateName: 'app.evv.devHelp'
        });
        // Lets the EVV section itself show when this is its only item.
        $rootScope.showEvvDevHelp = true;
      }).catch(function () {
        // No entry on failure.
      });
    }

    // Not inside the onboarding-agency block above: that block is for the onboarding
    // agency only.
    // Daily Notes is a FreedomCare feature: the notes come from FreedomCare's caregiver
    // app. Within FreedomCare it is offered only when an office is in the review
    // workflow. The server owns that list, so enabling the next office is one database
    // row rather than a release of this file.
    if (!$rootScope.isFCAgency || !$rootScope.agencyId || !$rootScope.agencyMemberId) {
      return;
    }

    DatabaseApi.get(
      'agencies/' + $rootScope.agencyId + '/agency_members/' +
      $rootScope.agencyMemberId + '/visit_daily_notes/offices'
    ).then(function (res) {
      if (!res || !res.data || !res.data.offices || res.data.offices.length === 0) {
        return;
      }

      // One entry. Attestations used to be a second nav item, and is now a tab of
      // this same page -- the two are the same data at different grains (one row per
      // note, one row per signed batch), so they belong behind one link.
      // The watch can fire more than once; the entry must not be listed twice.
      var alreadyListed = $rootScope.navigationItems.visits.subItems.some(function (item) {
        return item.stateName === 'app.visits.dailyNoteOverview';
      });

      if (alreadyListed) {
        return;
      }

      $rootScope.navigationItems.visits.subItems.push({
        text: 'Daily Notes',
        stateName: 'app.visits.dailyNoteOverview',
        permissionKey: 'view_visits_section_daily_notes',
        releaseDate: LocalDate.of(2026, 9, 14)
      });
    }).catch(function () {
      // A failure here means no entry, which is the safe direction: the route
      // is still permission-gated if someone has the link.
    });
  })

    $rootScope.navigationItems.reports.subItems.push({
      text: 'CICO Reports',
      stateName: 'app.reports.cicoReports',
      permissionKey: "view_cico_issues_visits",
      allowedAgencies: [6205]
  });

  $rootScope.sidenavHover = function(section) {
    $rootScope.sidenavHoveredSection = section || '';
  }

  $rootScope.sidenavFocus = function(section, stopPropagation) {
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (!section || $rootScope.sidenavFocusedSection === section) {
      $rootScope.sidenavFocusedSection = '';
    } else {
      $rootScope.sidenavFocusedSection = section;
    }
  }

  var resetFocus = function() {
    var pathArr = $location.$$path.split('/');
    if (pathArr.length < 3) {
      $rootScope.sidenavFocus();
    } else {
      $rootScope.sidenavFocus(pathArr[2]);
    }
  }

  /**
   * Which navigation entry the state we are in belongs to.
   *
   * Worked out from `navigationItems` - the same list the sidebar draws - rather than from the URL,
   * so a state whose url does not start with its section still lands in the right place. The entry
   * with the longest match wins: a sub item that is exactly the state beats one that only shares
   * its page, which is what tells `app.calls.rejected` from its siblings.
   *
   * A tab is matched through the page it belongs to. `app.patients.servicePlans.plans` is not under
   * the entry that points at `...servicePlans.imports`, but they are two tabs of one page, so the
   * entry's parent state is what the current state is compared against.
   */
  var findSidenavEntryOfState = function(stateName) {
    var best = null;

    var consider = function(candidateState, section, subItem) {
      if (!candidateState) {
        return;
      }

      var parentState = candidateState.split(".").slice(0, -1).join(".");
      var weight = null;

      if (stateName === candidateState || stateName.indexOf(candidateState + ".") === 0) {
        weight = candidateState.length;
      } else if (parentState !== "" && stateName.indexOf(parentState + ".") === 0) {
        weight = parentState.length;
      }

      if (weight !== null && (best === null || weight > best.weight)) {
        best = { weight: weight, section: section, subItem: subItem };
      }
    };

    Object.keys($rootScope.navigationItems || {}).forEach(function(key) {
      var item = $rootScope.navigationItems[key];

      consider(item.stateName, item.sectionName, null);
      (item.subItems || []).forEach(function(subItem) {
        consider(subItem.stateName, item.sectionName, subItem);
      });
    });

    return best;
  };

  /** Whether this sub item is the one the state we are in belongs to, tabs included. */
  $rootScope.isSidenavSubItemSelected = function(subItem) {
    var entry = findSidenavEntryOfState($state.current.name || "");

    return entry !== null && entry.subItem === subItem;
  };

  // The sidebar knew which section it was in only because someone clicked it. Anything that
  // navigates on its own - the AI omnibar, a bookmarked tab URL, a redirect - left it showing
  // whichever section was last opened by hand. Assigned rather than passed to sidenavFocus, which
  // toggles when handed the section it already has.
  $transitions.onSuccess({}, function() {
    var entry = findSidenavEntryOfState($state.current.name || "");

    if (entry !== null && entry.section) {
      $rootScope.sidenavFocusedSection = entry.section;
    }
  });

  $rootScope.sidenavHover();
  resetFocus();

  var ivrPhoneNumbersCollapsedKey = "sidenavIvrPhoneNumbersCollapsed";

  $rootScope.isIvrPhoneNumbersCollapsed = Storage.get(ivrPhoneNumbersCollapsedKey, "true") === "true";

  $rootScope.toggleIvrPhoneNumbers = function() {
    $rootScope.isIvrPhoneNumbersCollapsed = !$rootScope.isIvrPhoneNumbersCollapsed;
    Storage.set(ivrPhoneNumbersCollapsedKey, $rootScope.isIvrPhoneNumbersCollapsed);
  }

  $rootScope.settingsMouseenterHandler = function() {
    $rootScope.isSettingsHovered = true;
  }

  $rootScope.settingsMouseleaveHandler = function() {
    $rootScope.isSettingsHovered = false;
  }

  $rootScope.goToDashboard = function() {
    $state.go('app.dashboard');
  }

  $rootScope.goTo = function(state) {
    $state.go(state, {}, {
      reload: true
    });
  }

  $rootScope.isPermittedByKey = (permissionKey) => {
    const permissions =
      $rootScope.user.agencyMember.permisions ?? Storage.getObject("user").permissions;

    if (!Array.isArray(permissions)) {
      console.error("Permissions are not an array", permissions);
      return false;
    }

    return permissions.includes(permissionKey);
  }

  $rootScope.dateFormat = "MM/dd/yyyy"
  $rootScope.dateMaskFormat = "99/99/9999"

  // `name` is the same string DayOfWeek.name() returns, precomputed so a template
  // can use it as an object key in an ng-model expression without calling a
  // method inside one.
  $rootScope.daysOfWeekShortMap = [
    { id: DayOfWeek.valueOf("MONDAY"), name: "MONDAY", label: "Mo", fullLabel: "Monday" },
    { id: DayOfWeek.valueOf("TUESDAY"), name: "TUESDAY", label: "Tu", fullLabel: "Tuesday" },
    { id: DayOfWeek.valueOf("WEDNESDAY"), name: "WEDNESDAY", label: "We", fullLabel: "Wednesday" },
    { id: DayOfWeek.valueOf("THURSDAY"), name: "THURSDAY", label: "Th", fullLabel: "Thursday" },
    { id: DayOfWeek.valueOf("FRIDAY"), name: "FRIDAY", label: "Fr", fullLabel: "Friday" },
    { id: DayOfWeek.valueOf("SATURDAY"), name: "SATURDAY", label: "Sa", fullLabel: "Saturday" },
    { id: DayOfWeek.valueOf("SUNDAY"), name: "SUNDAY", label: "Su", fullLabel: "Sunday" }
  ];

  // When imported as a <script> tag, ChartDataLabels is being used the globally
  // So we must unregister it from all charts and add it manually to the wanted ones.
  Chart.unregister(ChartDataLabels);

  let isActiveIncrement = 0;
  document.addEventListener("keypress", (e) => {
    if (e.key === "`") {
      isActiveIncrement++;
    }

    if (isActiveIncrement >= 10) {
        isActiveIncrement = 0;
        $rootScope.openApiOverrideModal();
    }
  });
  // DEV-4926 Disable input change when scrolling and the cursor focus is on <input type="number" />
  document.addEventListener("wheel", (e) => {
    if (document.activeElement.type === "number") {
      document.activeElement.blur();
    }
  });

  $rootScope.openApiOverrideModal = () => {
    $uibModal.open({
        templateUrl: 'admin/views/switch-env.html',
        size: 'md',
        controller: 'switchEnv',
        windowClass: "switch-env-container center-center",
        backdrop: true,
        keyboard: true,
    });
  }

  $rootScope.resetApiOverride = () => {
      localStorage.removeItem("apiOverride");
      localStorage.removeItem("user");
      localStorage.removeItem("userEmail");
      window.location.reload();
  }

  $rootScope.checkDisplayBanner = function (time) {
    const today = LocalDate.now();
    return time && time.plusDays(21).isAfter(today);
  };

};
